import React from 'react'
import styled from 'styled-components'
import dynamic from 'next/dynamic'
const Footer = dynamic(() => import('@/components/home/footer'))
const KPHead = dynamic(() => import('@/components/head'))
const TopNavigation = dynamic(() => import('@/components/top-navigation'))

import Head from 'next/head'
import { createResource, useResource } from '@/lib/i18n'

export const resource = createResource({
  en: {
    description:
      'The Terms of Service made by Kredit Pintar are a form of agreement that is set out in the form of a legal agreement between the user and Kredit Pintar',
  },
  id: {
    description:
      'Persyaratan Layanan yang dibuat oleh Kredit Pintar merupakan bentuk kesepakatan yang dituangkan dalam bentuk perjanjian yang legal antara pengguna dan Kredit Pintar',
  },
})

export const termsOfService = () => {
  const { t } = useResource(resource)
  const htmlContent = htmlContentRaw
  const styleContent = styleContentRaw

  return (
    <BannerBox>
      <KPHead metaTitle="privacyPolicy" />
      <Head>
        <meta name="description" content={t('description')} />
      </Head>
      <TopNavigation hideSwitch={true} />
      <div dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
      <style dangerouslySetInnerHTML={{ __html: styleContent }}></style>
      <Footer />
    </BannerBox>
  )
}
export default termsOfService

export const htmlContentRaw = `<div class="doc-content" style="opacity: 1; max-width: 100%; overflow-x: hidden">
  <div class="c65">
    <h1 class="c17" id="h.sevkikhabn2p">
      <span class="c14 c44 c20">KEBIJAKAN PRIVASI &ndash; PRIVACY POLICY</span>
    </h1>
    <p class="c15 c8">
      <span class="c3"
        >Kebijakan Privasi ini telah dibuat untuk melindungi dan menjaga privasi dan kerahasiaan dari Pengguna
        Platform. Pengguna diharapkan membaca Kebijakan Privasi ini dengan seksama sebelum menggunakan Layanan Kami
        yang diberikan melalui Platform ini. Kebijakan Privasi ini tidak berlaku terhadap situs web atau aplikasi
        mobile yang tidak dioperasikan oleh Kami yang Anda akses melalui Platform. Layanan-layanan tersebut diatur
        oleh kebijakan privasi yang muncul pada masing-masing situs atau aplikasi dimaksud. Tergantung sifat hubungan
        Anda dengan Kami, Anda akan menerima pemberitahuan-pemberitahuan privasi lainnya terkait rincian dari
        praktik-praktik privasi Kami. Dengan mengakses dan menggunakan Layanan di Platform, Pengguna mengakui telah
        membaca, memahami dan menyetujui setiap ketentuan yang tertulis dalam Kebijakan Privasi ini dan ketentuan
        penggunaan dari Platform. Apabila Anda tidak menyetujui Kebijakan Privasi atau ketentuan penggunaan dari
        Platform, mohon agar tidak menggunakan Platform. Platform tidak untuk digunakan di luar negara atau yurisdiksi
        atau oleh orang yang dapat menjadikan penggunaannya melanggar hukum. Apabila Anda termasuk kategori ini, Anda
        tidak diperkenankan untuk mengakses atau menggunakan Platform. Platform ini dirancang dan dimaksudkan untuk
        digunakan oleh orang-orang yang bertempat tinggal di Indonesia. Apabila Anda mengakses Platform ini dari luar
        wilayah Indonesia, harap mengonfirmasikan terlebih dahulu bahwa peraturan perundang-undangan di negara Anda
        bertempat tinggal mengizinkan penggunaan Platform ini. Apabila pengunaan Platform dilarang di negara tempat
        Anda bertempat tinggal, kami menyarankan agar Anda tidak mengakses atau menggunakan Platform.</span
      >
    </p>
    <p class="c15 c8">
      <span class="c4"
        >This Privacy Policy is made to protect and maintain the privacy and confidentiality of the Platform Users.
        Users are expected to read this Privacy Policy carefully before using Our Services provided in this Platform.
        This Privacy Policy does not apply to any websites or mobile applications which are not operated by Us that
        You may access via the Platform. Such services are governed by the privacy policies appearing on those sites
        and applications. Depending upon Your relationship with Us, You may receive other privacy notices from Us
        providing additional detail about Our privacy practices. By accessing and using the Services provided in the
        Platform, Users acknowledge that they have read, understood and agreed to the content written in this Privacy
        Policy and the Platform&rsquo;s terms of use. If You do not agree to this Privacy Policy or the
        Platform&rsquo;s terms of use, please do not use the Platform. This Platform is designed and intended for use
        by persons residing in Indonesia. If You are accessing this Platform from outside Indonesia, please first
        confirm that the laws in Your country of residence permit the use of this Platform. If the use of the Platform
        is prohibited in Your country of residence, We strongly advise that You do not access or use the
        Platform.</span
      >
    </p>
    <p class="c11 c8"><span class="c3">&nbsp;</span></p>
    <p class="c29"><span class="c20">PASAL 1 &ndash;</span><span class="c12 c14">&nbsp;ARTICLE 1</span></p>
    <p class="c29"><span class="c20">DEFINISI &ndash; </span><span class="c14 c12">DEFINITION</span></p>
    <p class="c15 c8">
      <span class="c3"
        >Selain yang telah ditentukan pada bagian lain dalam Kebijakan Privasi ini, istilah-istilah berikut akan
        memiliki definisi, pengertian dan penafsiran sebagaimana ditentukan di bawah ini:</span
      >
    </p>
    <p class="c15 c9">
      <span class="c4"
        >Other than stipulated in this Privacy Policy, the following definitions shall have the definition, meanings
        and interpretation as stipulated below:</span
      >
    </p>
    <p class="c15 c8">
      <span>&ldquo;</span><span class="c20">Anda</span
      ><span class="c3"
        >&rdquo; berarti merujuk pada Penerima Dana, Pemberi Dana atau orang lain yang menggunakan Platform dan/atau
        Layanan baik terdaftar pada Platform maupun tidak.
      </span>
    </p>
    <p class="c15 c8">
      <span class="c25">&quot;</span><span class="c12">You</span><span class="c25">&quot; or &ldquo;</span
      ><span class="c12">Your</span
      ><span class="c4"
        >&rdquo; (as the context may require) means the Borrower, the Lender or other person who uses the Platform
        and/or Services whether registered or not in the Platform.</span
      >
    </p>
    <p class="c15 c8">
      <span>&ldquo;</span><span class="c20">Informasi Pribadi</span
      ><span class="c3"
        >&rdquo; berarti meliputi segala data, keterangan, informasi dan dokumen, baik elektronik maupun
        non-elektronik yang dapat mengidentifikasi seseorang, termasuk Kontak Terdaftar dan informasi dari maupun
        sehubungan dengan Pengguna (baik Penerima Dana maupun Pemberi Dana, sesuai konteksnya) dan/atau pihak terkait
        dengan Pengguna (termasuk namun tidak terbatas pada keluarga, rekan, karyawan, perwakilan perusahaan atau
        penyedia jasa Pengguna, apabila dipersyaratkan) yang Kami terima atau akses dari Pengguna, diajukan, diberikan
        atau diungkapkan oleh Pengguna kepada Kami, berdasarkan persetujuan Pengguna serta disimpan dan dikelola
        sehubungan dengan penyediaan Layanan pada Platform, dan dalam rangka pemanfaatan Layanan pada Platform oleh
        Pengguna.</span
      >
    </p>
    <p class="c15 c8">
      <span class="c25">&ldquo;</span><span class="c12">Personal Information</span
      ><span class="c4"
        >&rdquo; means all data, statements, information and documents, both in electronic and non-electronic form
        that may identify an individual, including the Registered Contact and information of or relevant to Users
        (both Borrowers and Lenders, according to the context) and/or any parties related to the User (including but
        not limited to family, colleagues, employees, representatives of companies or the User&rsquo;s service
        providers, if required) received or accessed by Us from the User, submitted, given or disclosed by the User to
        Us, according to the User&#39;s consent and stored and managed in connection with the provision of Services on
        the Platform, and in order to use the Services on the Platform by Users.</span
      >
    </p>
    <p class="c15 c8">
      <span>&ldquo;</span><span class="c20">Gagal Bayar</span
      ><span class="c3"
        >&rdquo; berarti suatu peristiwa dimana Penerima Dana telah gagal dalam membayar atau melakukan kewajibannya
        untuk melunasi Pendanaan sebagaimana diatur dalam Perjanjian Pendanaan.</span
      >
    </p>
    <p class="c15 c8">
      <span class="c25">&quot;</span><span class="c12">Failure of Payment</span
      ><span class="c4"
        >&quot; means an event where the Borrower has failed to pay or perform its obligations to repay the Loan as
        set forth in the Loan Agreement.</span
      >
    </p>
    <p class="c15 c8">
      <span>&ldquo;</span><span class="c20">Kami</span
      ><span class="c3"
        >&rdquo; berarti PT Kredit Pintar Indonesia, yaitu perseroan terbatas yang melaksanakan kegiatan usaha LPBBTI
        (sebagaimana didefinisikan di bawah ini) berdasarkan POJK 10 untuk memfasilitasi Pendanaan dari Pemberi Dana
        kepada Penerima Dana.</span
      >
    </p>
    <p class="c15 c8">
      <span class="c25">&quot;</span><span class="c12">We</span><span class="c25">&rdquo; or </span
      ><span class="c12">&ldquo;Us</span><span class="c25">&quot; or &ldquo;</span><span class="c12">Our</span
      ><span class="c4"
        >&rdquo; (as the context may require) means PT Kredit Pintar Indonesia, a limited liability company that is
        engaged in LPBBTI (as defined below) business activities based on POJK 10 to facilitate Loans from the Lender
        to the Borrower.</span
      >
    </p>
    <p class="c15 c8">
      <span>&ldquo;</span><span class="c20">Kontak Terdaftar</span
      ><span class="c3"
        >&rdquo; berarti nomor kontak individu yang dicantumkan Penerima Dana pada saat mengajukan Permohonan
        Pendanaan kepada Kami melalui Platform, dimana nomor tersebut dapat dan akan dihubungi oleh Kami ketika
        Penerima Dana telah dikategorikan Gagal Bayar.</span
      >
    </p>
    <p class="c15 c8">
      <span class="c25">&quot;</span><span class="c12">Registered Contact&quot; </span
      ><span class="c4"
        >means the individual contact number submitted by the Borrower when applying for the Loan Application to Us
        through the Platform, whereby such number can and will be contacted by Us whenever the Borrower is declared as
        committing a Failure of Payment.</span
      >
    </p>
    <p class="c15 c8">
      <span>&ldquo;</span><span class="c20">Kuasa</span
      ><span
        >&rdquo; berarti pemberian kuasa sebagaimana dimaksud dalam Pasal 1792 Kitab Undang- Undang Hukum Perdata
        (&ldquo;</span
      ><span class="c20">KUHPerdata</span
      ><span class="c3"
        >&rdquo;) dari Pemberi Dana kepada Kami untuk mewakili dan bertindak untuk dan atas nama serta demi
        kepentingan Pemberi Dana untuk:</span
      >
    </p>
    <p class="c15 c8">
      <span class="c25">&quot;</span><span class="c12">Proxy</span
      ><span class="c25"
        >&quot; means a grant of authority as referred to in Article 1792 of the Civil Code (&quot;</span
      ><span class="c12">Civil Code</span
      ><span class="c4"
        >&quot;) from the Lender to Us, to represent and act for and on behalf of and for the benefit of the Lender
        to:</span
      >
    </p>
    <p class="c1">
      <span class="c3"
        >(a) memberikan kesepakatan, perancangan, negosiasi, penandatanganan, implementasi maupun restrukturisasi
        Perjanjian Pendanaan;</span
      >
    </p>
    <p class="c15 c16">
      <span class="c4">provide consent, draft, negotiate, sign, implement and restructure the Loan Agreement;</span>
    </p>
    <p class="c1">
      <span class="c3"
        >(b) melakukan penagihan Pendanaan dari Penerima Dana berdasarkan Perjanjian Pendanaan serta menerima dan
        mengembalikan dana hasil pembayaran kembali Pendanaan dari Penerima Dana kepada Pemberi Dana; dan</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >collect Loans from the Borrower based on the Loan Agreement, and to receive and return funds received from
        the Loan repayment from the Borrower to the Lender; and</span
      >
    </p>
    <p class="c1">
      <span class="c3"
        >(c) melakukan tindakan-tindakan lain terkait yang sewajarnya diperlukan untuk pelaksanaan Perjanjian
        Pendanaan, kepatuhan terhadap UU PDP, POJK 10, surat edaran OJK terkait dan peraturan perundang-undangan yang
        mempengaruhi terkait LPBBTI, Perjanjian Penyaluran Dana dan Perjanjian Pendanaan serta pemenuhan hak dan
        kewajiban Pemberi Dana berdasarkan Perjanjian Pendanaan.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >perform any other related actions that are reasonably necessary for the implementation of the Loan Agreement,
        in compliance with the PDP Law, POJK 10, relevant OJK circular letters and laws and regulations that affect or
        need attention regarding LPBBTI, Loan Distribution Agreement, Loan Agreement and fulfillment of the rights and
        obligations of the Lender based on a Loan Agreement.</span
      >
    </p>
    <p class="c15 c8">
      <span>&ldquo;</span><span class="c20">Layanan</span
      ><span class="c3"
        >&rdquo; berarti layanan jasa keuangan yang disediakan oleh Kami termasuk menyediakan Platform untuk
        mempertemukan Pemberi Dana dengan Penerima Dana dalam rangka melaksanakan kegiatan LPBBTI terkait penyaluran
        Pendanaan kepada Penerima Dana.</span
      >
    </p>
    <p class="c15 c8">
      <span class="c25">&quot;</span><span class="c12">Services</span
      ><span class="c4"
        >&quot; means financial services provided by Us including providing the Platform to connect the Lender with
        the Borrower in order to carry out LPBBTI activities related to distribution of the Loan to the
        Borrower.</span
      >
    </p>
    <p class="c15 c8">
      <span>&ldquo;</span><span class="c20">LPBBTI</span
      ><span class="c3"
        >&rdquo; berarti Layanan Pendanaan Bersama Berbasis Teknologi Informasi yang disediakan oleh Kami melalui
        Platform yang memampukan calon Peminjam untuk mengajukan Permohonan Pendanaan.</span
      >
    </p>
    <p class="c15 c8">
      <span class="c25">&ldquo;</span><span class="c12">LPBBTI</span
      ><span class="c4"
        >&rdquo; means an Information Technology-Based Joint Funding Service provided by Us through the Platform which
        allows potential Borrowers to submit a Loan Application.</span
      >
    </p>
    <p class="c15 c8">
      <span>&ldquo;</span><span class="c20">Pemberi Dana</span
      ><span class="c3"
        >&rdquo; berarti pihak yang terdaftar dalam Platform untuk melakukan pendanaan berupa pemberian dan penyaluran
        Pendanaan kepada Penerima Dana melalui Platform.</span
      >
    </p>
    <p class="c15 c8">
      <span class="c25">&quot;</span><span class="c12">Lender</span
      ><span class="c4"
        >&quot; means a party registered on the Platform to provide funding by granting and distributing Loan to a
        Borrower through the Platform.</span
      >
    </p>
    <p class="c15 c8">
      <span>&ldquo;</span><span class="c20">Penerima Dana</span
      ><span class="c3"
        >&rdquo; berarti pihak yang terdaftar dalam Platform untuk menerima pendanaan dari Pemberi Dana melalui
        Platform.</span
      >
    </p>
    <p class="c15 c8">
      <span class="c25">&quot;</span><span class="c12">Borrower</span
      ><span class="c4"
        >&quot; means a party registered on the Platform to receive funding in the form of a Loan from the Lender
        through the Platform.</span
      >
    </p>
    <p class="c15 c8">
      <span>&ldquo;</span><span class="c20">Pengguna</span
      ><span class="c3">&rdquo; berarti baik Pemberi Dana maupun Penerima Dana sebagaimana konteksnya relevan.</span>
    </p>
    <p class="c15">
      <span class="c25">&quot;</span><span class="c12">User</span
      ><span class="c4">&quot; means either or both the Lender and the Borrower as the context requires.</span>
    </p>
    <p class="c15 c8">
      <span>&ldquo;</span><span class="c20">Perjanjian Penyaluran Pendanaan</span
      ><span class="c3"
        >&rdquo; berarti perjanjian antara Kami dan Pemberi Dana untuk penyaluran dana Pendanaan dari Pemberi Dana
        kepada Penerima Dana melalui Platform.</span
      >
    </p>
    <p class="c15 c8">
      <span class="c25">&quot;</span><span class="c12">Loan Distribution Agreement</span
      ><span class="c4"
        >&quot; means an agreement entered into by and between the Lender and Us for the distribution of Loan funds
        from the Lender to the Borrower through the Platform.</span
      >
    </p>
    <p class="c15 c8">
      <span>&ldquo;</span><span class="c20">Perjanjian Pendanaan</span
      ><span class="c3"
        >&rdquo; berarti kesepakatan tertulis yang disepakati antara Pemberi Dana dan Penerima Dana yang mengatur
        antara lain hak dan kewajiban Pemberi Dana dan Penerima Dana, syarat dan ketentuan penyaluran Pendanaan dari
        Pemberi Dana melalui Kami kepada Penerima Dana, dan prosedur pengembalian atau pembayaran Pendanaan beserta
        setiap amandemen, perpanjangan dan lampiran- lampirannya.</span
      >
    </p>
    <p class="c15 c8">
      <span class="c25">&quot;</span><span class="c12">Loan Agreement</span
      ><span class="c4"
        >&quot; means a written agreement agreed upon between the Lender and the Borrower which regulates, among other
        things, the rights and obligations of the Lender and Borrower, terms and conditions of distribution of the
        Loan from the Lender through Us to the Borrower, and the procedure for the return or repayment of the Loan
        together with any amendments, extensions and attachments.</span
      >
    </p>
    <p class="c15 c8">
      <span>&ldquo;</span><span class="c20">Pendanaan</span
      ><span class="c3"
        >&rdquo; berarti fasilitas Pendanaan baik Pendanaan baru atau berulang (berikut bunga, penalti keterlambatan
        atas Pendanaan baru atau berulang dan kewajiban finansial lainnya) dari Pemberi Danayang disalurkan Pemberi
        Dana kepada Penerima Dana melalui Platform berdasarkan Perjanjian Pendanaan.</span
      >
    </p>
    <p class="c15 c8">
      <span class="c25">&quot;</span><span class="c12">Loan</span
      ><span class="c4"
        >&quot; means loan facilities either for new or recurring Loan (including interest, late repayment penalty for
        new or recurring Loan and other financial obligations) from the Lender distributed to the Borrower through the
        Platform based on the Loan Agreement.</span
      >
    </p>
    <p class="c15 c8">
      <span>&ldquo;</span><span class="c20">Platform</span
      ><span
        >&rdquo; adalah (a) portal web dan/atau versi mobile dari portal web yang dibuat, dimiliki dan dioperasikan
        oleh Kami yang saat ini dapat diakses pada URL berikut: </span
      ><span class="c23"
        ><a
          class="c47"
          href="https://www.google.com/url?q=http://www.kreditpintar.com/&amp;sa=D&amp;source=editors&amp;ust=1679460588497835&amp;usg=AOvVaw3WYtXNtJIrBxPm5PJ0Vm1O"
          >www.kreditpintar.com
        </a></span
      ><span class="c3">beserta setiap perubahan URL tersebut dari waktu ke waktu; dan/atau</span>
    </p>
    <p class="c15">
      <span class="c3">(b) aplikasi mobile dibuat, dimiliki dan dioperasikan oleh Kami.</span>
    </p>
    <p class="c15 c8">
      <span class="c25">&ldquo;</span><span class="c12">Platform</span
      ><span class="c25"
        >&rdquo; is (a) web portal and/or mobile version of web portals created, owned and operated by Us which can
        currently be accessed at the following URL: </span
      ><span class="c23 c25"
        ><a
          class="c47"
          href="https://www.google.com/url?q=http://www.kreditpintar.com/&amp;sa=D&amp;source=editors&amp;ust=1679460588498667&amp;usg=AOvVaw3CMzTYeKjdJwoQvjucS0ZB"
          >www.kreditpintar.com</a
        ></span
      ><span class="c4"
        >&nbsp;along with any URL changes from time to time; and/or (b) mobile applications created, owned and
        operated by Us.</span
      >
    </p>
    <p class="c15 c8">
      <span>&ldquo;</span><span class="c20">POJK 10</span
      ><span class="c3"
        >&rdquo; berarti Peraturan Otoritas Jasa Keuangan No.10/POJK.05/2022 tentang Layanan Pendanaan Bersama
        Berbasis Teknologi Informasi sebagaimana diubah, diamandemen, dimodifikasi atau ditambahkan dari waktu ke
        waktu.</span
      >
    </p>
    <p class="c15 c8">
      <span class="c25">&ldquo;</span><span class="c12">POJK 10</span
      ><span class="c4"
        >&rdquo; means Financial Services Authority Regulation No.10/POJK.05/2022 on Information Technology Based
        Joint Funding Services as amended, modified or added from time to time.</span
      >
    </p>
    <p class="c15 c8">
      <span>&ldquo;</span><span class="c20">UU ITE</span
      ><span class="c3"
        >&rdquo; berarti Undang-Undang Republik Indonesia Nomor 11 Tahun 2008 tentang Informasi dan Transaksi
        Elektronik sebagaimana terakhir kali diubah oleh Undang-Undang Republik Indonesia Nomor 19 Tahun 2016.</span
      >
    </p>
    <p class="c15 c8">
      <span class="c25">&ldquo;</span><span class="c12">ITE Law</span
      ><span class="c4"
        >&rdquo; means the Law of the Republic of Indonesia Number 11 of 2008 on Information and Electronic
        Transaction as lastly amended by Law Number 19 of 2016.</span
      >
    </p>
    <p class="c15 c8">
      <span>&ldquo;</span><span class="c20">UU PDP</span
      ><span class="c3"
        >&rdquo; berarti Undang-Undang Republik Indonesia Nomor 27 Tahun 2022 tentang Perlindungan Data Pribadi</span
      >
    </p>
    <p class="c8 c15">
      <span class="c25">&ldquo;</span><span class="c12">PDP Law</span
      ><span class="c4"
        >&rdquo; means Law of the Republic of Indonesia Number 27 of 2022 regarding Personal Data Protection.</span
      >
    </p>
    <p class="c15 c8 c43"><span class="c4"></span></p>
    <p class="c29"><span class="c20">PASAL 2 &ndash;</span><span class="c14 c12">&nbsp;ARTICLE 2</span></p>
    <p class="c49 c60"><span class="c20">PENDAHULUAN &ndash; </span><span class="c14 c12">RECITALS</span></p>
    <p class="c1">
      <span class="c3"
        >2.1 Dengan mengakses Platform dan/atau memberikan Informasi Pribadi kepada Kami, Anda telah membaca dan
        mengerti Kebijakan Privasi kami dan setuju atas pengumpulan, pemrosesan dan pengungkapan Informasi Pribadi
        sesuai dengan Kebijakan Privasi ini termasuk mengenai penggunaan Kontak Terdaftar sebagaimana diatur dalam
        Pasal 4.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >By accessing the Platform and/or providing Personal Information to Us, You have read and understood Our
        Privacy Policy and consent to the collection, use and disclosure of Your Personal Information in accordance
        with this Privacy Policy including the provisions regarding the use of the Registered Contact
        &nbsp;information as stipulated in Article 4.</span
      >
    </p>
    <p class="c1">
      <span class="c3"
        >2.2 Persetujuan Anda secara elektronik sebagaimana dimaksud dalam Pasal 2.1 di atas adalah:</span
      >
    </p>
    <p class="c6">
      <span class="c4">Your electronic consent as referred to in Article 2.1 above shall:</span>
    </p>
    <p class="c6">
      <span class="c3"
        >(a) dianggap cukup untuk menunjukan persetujuan sebagaimana dimaksud dalam Pasal 1320 KUHPer sebagai syarat
        sahnya suatu perjanjian serta setiap formalitas persetujuan sebagaimana diatur di dalam UU PDP;</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >be sufficient consent for the purposes of Article 1320 of the Civil Code as a condition for the validity of
        an agreement as well as any formality of consent as set out under PDP Law;</span
      >
    </p>
    <p class="c35 c16">
      <span class="c3"
        >(b) dikualifikasikan sebagai alat bukti hukum yang sah berdasarkan Pasal 5 ayat 1 UU ITE; dan</span
      >
    </p>
    <p class="c6">
      <span class="c4">qualify as valid legal evidence based on Article 5 paragraph 1 of the ITE Law; and</span>
    </p>
    <p class="c35 c16">
      <span class="c3"
        >(c) merupakan instrumen pembuktian yang diterima sebagai bagian dari konsep pembuktian secara perdata dalam
        pengadilan menurut Pasal 1865 KUHPer.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >constitute an instrument of proof received as part of the concept of civil evidentiary proof in court
        according to Article 1865 Civil Code.</span
      >
    </p>
    <p class="c1">
      <span class="c3">
        2.3 Kami hanya dapat mengakses, memperoleh, menyimpan, mengelola, memproses, dan/atau menggunakan Data Pribadi
        Anda setelah Kami mendapatkan persetujuan dari Anda.
      </span>
    </p>
    <p class="c6">
      <span class="c4">
        We can only access, obtain, store, manage, process, and/or use Your Personal Data after obtaining your
        consent.
      </span>
    </p>
    <p class="c15"><span class="c24 c64">&nbsp;</span></p>
    <p class="c29"><span class="c20">PASAL 3 &ndash; </span><span class="c14 c12">ARTICLE 3</span></p>
    <p class="c17">
      <span class="c20">INFORMASI PRIBADI &ndash; </span><span class="c14 c12">PERSONAL INFORMATION</span>
    </p>
    <p class="c15">
      <span class="c5">PENGUMPULAN, PENGGUNAAN DAN PENGUNGKAPAN INFORMASI PRIBADI &ndash; </span
      ><span class="c5 c39 c22 c25">PERSONAL INFORMATION COLLECTION, USAGE, AND DISCLOSURE</span>
    </p>
    <p class="c1">
      <span class="c3"
        >3.1 Agar Anda dapat mengakses Platform dan agar Kami dapat menyediakan Layanan, Kami akan memperoleh,
        mengumpulkan, mengolah, menganalisa, menyimpan, menampilkan, mengumumkan, mentransfer, menyebarluaskan,
        mengungkapkan Informasi Pribadi Anda dan informasi lainnya yang dibutuhkan yang diperoleh melalui Platform
        dengan persetujuan Anda atau dengan penyediaan pemberitahuan sebelumnya.
      </span>
    </p>
    <p class="c6">
      <span class="c4"
        >In order for You to access the Platform and for Us to provide the Services, We shall obtain, collect,
        process, analyse, store, display, announce, transfer, disseminate, disclose Your Personal Information and
        other necessary information obtained through the Platform with Your consent or having provided prior
        notice.</span
      >
    </p>
    <p class="c1">
      <span class="c3">3.2 Informasi Pribadi yang mungkin Kami kumpulkan termasuk:</span>
    </p>
    <p class="c15 c16">
      <span class="c4">Personal Information which We may collect include:</span>
    </p>
    <p class="c2"><span class="c3 c55">&nbsp;</span></p>
    <a id="t.c2622d87d916993b12a6da8af74feaa3837e827b"></a><a id="t.0"></a>
    <table class="c50">
      <tr class="c51">
        <td class="c40" colspan="1" rowspan="1">
          <p class="c13">
            <span class="c14 c44 c20">Informasi Pribadi Umum</span>
          </p>
          <p class="c13">
            <span class="c14 c12">General Personal Information</span>
          </p>
        </td>
        <td class="c18" colspan="1" rowspan="1">
          <p class="c13">
            <span class="c14 c44 c20">Informasi Pribadi Spesifik</span>
          </p>
          <p class="c13">
            <span class="c14 c12">Specific Personal Information</span>
          </p>
        </td>
      </tr>
      <tr class="c56">
        <td class="c40" colspan="1" rowspan="1">
          <p class="c13">
            <span class="c3"
              >informasi pribadi Anda, seperti nama, nomor paspor atau nomor induk kependudukan, tanggal kelahiran,
              status perkawinan, dan jenis kelamin;</span
            >
          </p>
          <p class="c13">
            <span class="c4"
              >your personal information such as Your name, Identification/Passport number, date of birth, marital
              status, gender;</span
            >
          </p>
        </td>
        <td class="c18" colspan="1" rowspan="1">
          <p class="c13">
            <span class="c3"
              >informasi pembayaran dan keuangan Anda, seperti pendapatan dan informasi pembayaran kembali;</span
            >
          </p>
          <p class="c13">
            <span class="c4">your financial and payment information such as income and repayment information;</span>
          </p>
          <p class="c13 c59"><span class="c3">&nbsp;</span></p>
        </td>
      </tr>
      <tr class="c67">
        <td class="c40" colspan="1" rowspan="1">
          <p class="c13">
            <span class="c3"
              >informasi kontak Anda seperti alamat tempat tinggal atau kode pos, alamat email, nomor telepon, nomor
              handphone dan nomor fax.</span
            >
          </p>
          <p class="c13">
            <span class="c4"
              >your contact information such as residential or postal addresses, email addresses, telephone, mobile
              phone and fax numbers;</span
            >
          </p>
        </td>
        <td class="c18" colspan="1" rowspan="1">
          <p class="c13">
            <span class="c3">data biometric Anda seperti pengenalan wajah;</span>
          </p>
          <p class="c13">
            <span class="c4">your biometric data such as facial recognition;</span>
          </p>
        </td>
      </tr>
      <tr class="c68">
        <td class="c40" colspan="1" rowspan="1">
          <p class="c13"><span class="c3">-</span></p>
        </td>
        <td class="c18" colspan="1" rowspan="1">
          <p class="c13">
            <span class="c3">data geolokasi berdasarkan handphone atau peralatan elektronik lainnya milik Anda;</span>
          </p>
          <p class="c13">
            <span class="c4">geolocation data based on Your mobile or other electronic device;</span>
          </p>
        </td>
      </tr>
      <tr class="c66">
        <td class="c40" colspan="1" rowspan="1">
          <p class="c13"><span class="c3">-</span></p>
        </td>
        <td class="c18" colspan="1" rowspan="1">
          <p class="c13">
            <span class="c3">data terkait referensi kredit, penagihan utang dan pencegahan penipuan;</span>
          </p>
          <p class="c13">
            <span class="c4">credit reference, debt collection and fraud prevention data</span>
          </p>
        </td>
      </tr>
      <tr class="c62">
        <td class="c37" colspan="2" rowspan="1">
          <p class="c15">
            <span class="c3"
              >informasi lainnya yang mungkin diperlukan untuk Kami kumpulkan, yang bergantung pada kontes, acara,
              iklan, formulir, fitur yang Kami miliki atau layanan lainnya yang Anda gunakan atau mohonkan;</span
            >
          </p>
          <p class="c15">
            <span class="c4"
              >other information which We may need to collect, depending on the specific Kredit Pintar contest, event,
              campaign, form, feature or other service that You use or request;</span
            >
          </p>
        </td>
      </tr>
      <tr class="c63">
        <td class="c37" colspan="2" rowspan="1">
          <p class="c15">
            <span class="c3"
              >data terkait permohonan layanan pelanggan yang mungkin Anda layangkan atau keluhan yang Anda miliki
              yang dibutuhkan untuk menyelesaikan keluhanan tersebut, termasuk rekaman suara yang dikumpulkan saat
              Anda menghubungi bagian layanan pelanggan Kami; dan/atau</span
            >
          </p>
          <p class="c15">
            <span class="c4"
              >data relating to any customer service requests You may raise or complaints You may have in order to
              resolve them, including audio recordings collected when You contact Our customer care unit; and/or</span
            >
          </p>
        </td>
      </tr>
      <tr class="c51">
        <td class="c37" colspan="2" rowspan="1">
          <p class="c15">
            <span class="c3">data dari sumber-sumber public dan data dari aggregator.</span>
          </p>
          <p class="c15">
            <span class="c4">data from public sources, and other data aggregators.</span>
          </p>
        </td>
      </tr>
    </table>
    <p class="c7"><span class="c3">&nbsp;</span></p>
    <p class="c1">
      <span class="c3">
        3.3 Sehubungan dengan pengumpulan Informasi Pribadi Anda melalui gawai milik Anda, Kami hanya dapat mengakses
        fitur kamera, lokasi dan mikrofon pada gawai milik Anda.
      </span>
    </p>
    <p class="c6">
      <span class="c4">
        In relation to the collection of Your Personal Information through Your device, we can only access Your
        device’s camera, location, and microphone features.
      </span>
    </p>
    <p class="c1">
      <span class="c3"
        >3.4 Kami akan/mungkin mengkumpulkan, menggunakan, mengungkapkan dan/atau memproses Informasi Pribadi Anda
        untuk tujuan(-tujuan) berikut ini:</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >We will/may collect, store, use, disclose and/or process Your Personal Information for the following
        purpose(s) of:</span
      >
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(a) penilaian, analisis, verifikasi, validasi atau pemeriksaan terhadap (i) Permohonan Pendanaan; (ii) proses
        atau permohonan pendaftaran sebagai Pemberi Dana atau Penerima Dana; dan/atau (iii) profil Anda;</span
      >
    </p>
    <p class="c2">
      <span class="c4"
        >appraisal, analysis, Identification and &nbsp;verification, validation or examination of (i) Loan
        Application; (ii) process or application for registration as a Lender or Borrower; and/or (iii) Your
        profile;</span
      >
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(b) melakukan verifikasi, penilaian risiko, analisis dan perencanaan statistik dan tren, termasuk
        melaksanakan Pengolahan data, analisis statistik, kredit, pengawasan risiko dan anti pencucian uang, membuat
        dan mengelola model penilaian kredit, melakukan pemeriksaan dan peninjauan kredit dan latar belakang lain dan
        menyimpan sejarah kredit Anda yang sah untuk referensi saat ini dan di masa mendatang;</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >conducting Identification and verification, risk assessments, statistical analysis and planning and trends,
        including carrying out data Processing, statistical analysis, credit, risk and anti money laundering
        screening, creating and managing credit assessment models, conducting credit checks, reviews and other
        backgrounds checks and keeping history of Your credit for current and future reference;</span
      >
    </p>
    <p class="c2 c10">
      <span class="c3"
        >(c) mengelola hubungan Kami dengan Anda yang dapat termasuk menyediakan informasi kepada Anda tentang
        Platform dan memungkinkan Anda untuk menggunakan Layanan yang disediakan oleh Platform, seperti untuk hal-hal
        sebagai berikut:</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >manage Our relationship with You which may include providing information to You regarding the Platform and
        allowing You to use the Services provided by the Platform, such as for the following matters:</span
      >
    </p>
    <p class="c2">
      <span class="c3">i. menghubungi Anda terkait dengan permintaan Anda;</span>
    </p>
    <p class="c2">
      <span class="c4">contacting You regarding Your request;</span>
    </p>
    <p class="c2">
      <span class="c3"
        >ii. untuk keperluan bisnis Kami secara umum termasuk untuk memverifikasi identitas Anda dan reputasi kredit
        Anda;</span
      >
    </p>
    <p class="c2 c9">
      <span class="c4"
        >for Our business needs in general, including verifying Your identity and credit reputation;</span
      >
    </p>
    <p class="c2">
      <span class="c3">iii. mengidentifikasi Anda ketika Anda menghubungi Kami atau mengunjungi</span>
    </p>
    <p class="c2"><span class="c3">Platform;</span></p>
    <p class="c2">
      <span class="c4">identifying You when You contact Us or visit the Platform;</span>
    </p>
    <p class="c2">
      <span class="c3"
        >iv. memberikan informasi yang memadai yang disimpan di Platform untuk mengidentifikasi Anda kepada Pemberi
        Dana dan/atau Penerima Dana;</span
      >
    </p>
    <p class="c2 c9">
      <span class="c4"
        >providing adequate information stored on the Platform to identify You to the Lender and/or Borrower;</span
      >
    </p>
    <p class="c2">
      <span class="c3"
        >v. mengizinkan bank, badan keuangan atau pihak ketiga yang berwenang guna mengadakan konfirmasi mengenai
        status Anda dalam database Kami atau Layanan (apabila diperlukan);</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >allowing banks, financial entities or authorized third parties to carry out confirmation regarding Your
        status in Our database or Services (if required);</span
      >
    </p>
    <p class="c2">
      <span class="c3"
        >vi. menangani pertanyaan atau keluhan yang dibuat oleh atau tentang Anda sehubungan dengan Platform dan
        disimpan untuk mencegah dan mendeteksi kecurangan, pelanggaran dan bentuk penyalahgunaan lainnya;</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >handling questions or complaints made by or related to You in connection with the Platform and stored to
        prevent and detect any fraud, infringement and other potential misuse from occuring;</span
      >
    </p>
    <p class="c2">
      <span class="c3"
        >vii. memverifikasi kepatuhan Anda terhadap persyaratan dan ketentuan yang mengatur penggunaan Platform;</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >verifying Your compliance with the terms and conditions governing the use of the Platform;</span
      >
    </p>
    <p class="c2">
      <span class="c3">viii. pengurusan rekening escrow Pengguna kepada pihak penyedia rekening escrow;</span>
    </p>
    <p class="c2">
      <span class="c4">managing the User&rsquo;s escrow account to the escrow account provider;</span>
    </p>
    <p class="c2 c8">
      <span class="c3">ix. memberitahu Anda tentang perubahan-perubahan terhadap Platform dan Layanan.</span>
    </p>
    <p class="c2">
      <span class="c4">notifying You regarding any changes to the Platform and Services.</span>
    </p>
    <p class="c2">
      <span class="c3">x. mengizinkan Anda berpartisipasi dalam Layanan fitur interaktif Kami;</span>
    </p>
    <p class="c2 c8">
      <span class="c4">allowing You to participate in Our interactive feature Services;</span>
    </p>
    <p class="c15 c16">
      <span class="c5">PENGEMBANGAN, PENINGKATAN DAN RISET PRODUK &ndash; </span
      ><span class="c5 c39 c22 c25">PRODUCT DEVELOPMENT, IMPROVEMENT AND RESEARCH</span>
    </p>
    <p class="c2 c10">
      <span
        >(d) Kami mungkin menggunakan Informasi Pribadi yang kami kumpulkan dari Anda untuk pengujian, pelaksanaan
        survey, riset, evaluasi, studi akademis, analisis dan pengembangan produk oleh Kami atau pihak ketiga lainnya
        apabila Anda telah menyepakati penggunaan oleh Kami untuk hal-hal tersebut. Hal ini memungkinkan Kami untuk
        memahami dan menganalisis preferensi dan kebutuhan Anda, mengembangkan fitur, produk dan layanan baru. Apabila
        Anda memilih agar data tidak digunakan untuk tujuan di atas, mohon hubungi </span
      ><span class="c45">cs@kreditpintar.com</span><span class="c3">.</span>
    </p>
    <p class="c2">
      <span class="c25"
        >We may use the Personal Information We collect from You for testing, conduct surveys, research, evaluations,
        academic studies, analysis and product development and offering either by Us or other third parties if You
        have consented for Us to do so. This allows Us to understand and analyse Your needs and preferences, develop
        new features, products and services. To opt out of use of data for the above purpose, please &nbsp; &nbsp;
        &nbsp;contact </span
      ><span class="c25 c45">cs@kreditpintar.com</span><span class="c4">.</span>
    </p>
    <p class="c15 c16">
      <span class="c5">KEPATUHAN DAN UNTUK MELINDUNGI KAMI DARI TUNTUTAN HUKUM &ndash; </span
      ><span class="c5 c39 c22 c25">COMPLIANCE AND TO PROTECT US FROM LEGAL CLAIMS</span>
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(e) memenuhi persyaratan hukum, regulasi dan kepatuhan yang berlaku terhadap Kami beserta Platform dan
        Layanan berdasarkan undang- undang yang berlaku dan mematuhi setiap perjanjian yang berlaku sehubungan dengan
        pelaksanaan Layanan;</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >fulfill any legal, regulatory and compliance requirements that apply to Us, the Platform and Services based
        on the prevailing laws and compliance with applicable agreements relating to the implementation of the
        Services;</span
      >
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(f) melaksanakan perintah atau kebijakan pemerintah, badan pengaturan atau instansi yang berwenang; dan</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >implement the instructions or policies of government, regulatory bodies or authorized agencies; and</span
      >
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(g) melakukan setiap investigasi berdasarkan hukum yang berlaku mengenai pemeriksaan anti pencucian uang dan
        pencegahan pendanaan terorisme di sektor jasa keuangan;</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >conducting investigations under the prevailing laws including anti-money laundering and prevention of
        terrorist financing in the financial services sector;</span
      >
    </p>
    <p class="c6">
      <span class="c5">PEMASARAN, ACARA DAN IKLAN &ndash; </span
      ><span class="c5 c39 c22 c25">MARKETING, EVENTS AND CAMPAIGNS</span>
    </p>
    <p class="c2 c10 c8">
      <span
        >(h) menyediakan, mengelola, mengembangkan dan menawarkan berbagai produk dan jasa kepada Anda apabila Anda
        telah menyepakati untuk menerima komunikasi tersebut. Apabila Anda memilih untuk tidak menerima komunikasi
        tersebut, mohon hubungi </span
      ><span class="c45">cs@kreditpintar.com</span><span class="c3">.</span>
    </p>
    <p class="c2 c8">
      <span
        >provide, manage, develop and offer You various products and services if You have consented to receiving these
        communications . To opt out of receiving such communication, please contact </span
      ><span class="c45">cs@kreditpintar.com</span><span class="c3">.</span>
    </p>
    <p class="c6">
      <span class="c5">UNTUK TUJUAN LAINNYA YANG ANDA TELAH BERIKAN PERSETUJUAN &ndash; </span
      ><span class="c5 c39 c22 c25">FOR ANY OTHER PURPOSE TO WHICH YOU CONSENT</span>
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(i) menggunakan Informasi Pribadi Anda untuk tujuan lain apa pun yang telah Anda berikan
        persetujuannya.</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >to use Your Personal Information for any other purpose to which You have provided consent.</span
      >
    </p>
    <p class="c1">
      <span class="c3"
        >3.5 Informasi Pribadi yang disampaikan oleh Anda kepada Kami untuk tujuan publikasi di Platform akan
        digunakan untuk tujuan tersebut sesuai dengan persetujuan yang telah Anda berikan kepada Kami berdasarkan
        Kebijakan Privasi ini.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >The Personal Information submitted by You to Us for publication purposes on the Platform will be used for the
        purposes in accordance with the consent that You have given to Us in this Privacy Policy.</span
      >
    </p>
    <p class="c15 c8">
      <span class="c5">PIHAK YANG MENERIMA INFORMASI PRIBADI ANDA DARI KAMI &ndash; </span
      ><span class="c5 c25">PARTIES WE SHARE YOUR PERSONAL INFORMATION WITH</span
      ><span class="c5 c24 c22">&nbsp;</span>
    </p>
    <p class="c1">
      <span class="c3"
        >3.6 Kami mungkin/akan perlu mengungkapkan Informasi Pribadi Anda kepada pihak ketiga, termasuk kepada bank,
        penyedia layanan pembayaran dan/atau payment gateway lainnya, baik yang berlokasi di dalam atau di luar
        wilayah Indonesia, untuk satu atau lebih tujuan di atas, sebagaimana pihak ketiga tersebut, akan memproses
        Informasi Pribadi Anda untuk satu atau lebih tujuan di atas. Kami telah menerapkan klausul kontrak standar dan
        langkah-langkah keamanan standar industri seperti enkripsi (baik saat diam maupun transit) untuk transfer
        Informasi Pribadi di luar wilayah Indonesia. Berdasarkan persetujuan dari Anda atau sepanjang diizinkan atau
        diwajibkan berdasarkan hukum yang berlaku, Kami dapat/diizinkan untuk mengungkapkan Informasi Pribadi Anda
        kepada pihak ketiga tersebut (baik yang berlokasi di dalam atau di luar Indonesia) untuk satu atau lebih
        tujuan di atas dan untuk pihak ketiga tersebut untuk selanjutnya mengumpulkan, menggunakan, mengungkapkan
        dan/atau memproses Informasi Pribadi Anda untuk atau lebih dari Tujuan di atas. Tanpa membatasi keumuman
        hal-hal tersebut di atas, pihak ketiga tersebut meliputi:</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >We may/will need to disclose Your Personal Information to third parties, including to banks, payment service
        providers and/or other payment gateways, whether located within or outside Indonesia, for one or more of the
        above purpose, as such third parties, would be processing Your Personal Information for one or more of the
        above purpose. We have implemented standard contractual clauses and industry standard security measures such
        as encryption (both at rest and in transit) for transfer of Personal Information outside Indonesia. With your
        consent or as otherwise permitted or required under applicable law, &nbsp;We may/are permitted to disclose
        Your Personal Information to such third parties (whether located within or outside Indonesia) for one or more
        of the above purpose and for the said third parties to subsequently collect, use, store, disclose and/or
        process Your Personal Information for one or more of the above purpose. Without limiting the generality of the
        foregoing, such third parties include:</span
      >
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(a) mitra kolaboratif, agen, kontraktor, atau penyedia layanan pihak ketiga Kami yang memproses atau akan
        memproses Informasi Pribadi Anda atas nama Kami termasuk mereka yang memberikan layanan administratif atau
        layanan lain kepada Kami seperti mailing house, perusahaan telekomunikasi, perusahaan teknologi informasi dan
        pusat data;</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >any of Our collaboration partners, agents, contractors or third party service providers that process or will
        be processing Your Personal Information on Our behalf including those which provide administrative or other
        services to Us such as mailing houses, telecommunication companies, information technology companies and data
        centres;</span
      >
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(b) setiap anggota grup Kami (yang berarti anak perusahaan Kami, afiliasi Kami, perusahaan induk utama Kami
        dan anak perusahaannya) dari waktu ke waktu untuk satu atau lebih tujuan; dan</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >any member of Our group (which means Our subsidiaries, Our affiliates, Our ultimate holding company and its
        subsidiaries) from time to time for one or more of the purposes; and</span
      >
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(c) mengungkapkan kepada pihak ketiga untuk mematuhi hukum, persyaratan hukum, perintah, arahan, atau
        permintaan apa pun dari pengadilan, otoritas, atau badan pemerintah di yurisdiksi mana pun, yang mungkin
        berada di dalam atau di luar Indonesia.</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >to disclose to a third party to comply with any law, legal requirements, orders, directions or requests from
        any court, authority or government body of any jurisdiction, which may be within or outside Indonesia.</span
      >
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(d) kami dapat membagikan informasi Anda dengan penyedia jasa CDD, penyedia jasa tanda tangan elektronik,
        badan pelaporan kredit atau entitas yang memiliki lisensi untuk memberikan nilai kredit (termasuk penyedia
        jasa informasi perkreditan alternatif).</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >we may share Your information with CDD service providers, electronic signature service providers, credit
        reporting bodies or entities that have license to provide credit scores (including alternative credit
        scores).</span
      >
    </p>
    <p class="c15 c8">
      <span class="c5">PENGUNGKAPAN INFORMASI PRIBADI ANDA KE LUAR WILAYAH INDONESIA &ndash; </span
      ><span class="c5 c39 c22 c25">DISCLOSURE OF YOUR PERSONAL INFORMATION OUTSIDE INDONESIA</span>
    </p>
    <p class="c1">
      <span class="c3"
        >3.7 Informasi Pribadi Anda dapat dipindahkan lintas batas oleh Kami sesuai dengan undang-undang yang berlaku
        dan jika ada dasar pemrosesan yang sah bagi Kami untuk melakukannya (seperti pelaksanaan kontrak antara Anda
        dan Kami, persetujuan Anda, dan/atau kewajiban hukum atau peraturan yang harus Kami penuhi). Informasi Pribadi
        Anda dapat ditransfer kepada anggota mana pun dari grup Kami yang berlokasi di berbagai negara. Kami akan
        mengambil langkah-langkah yang wajar untuk menjaga keamanan Informasi Pribadi selama transit dan di lokasi
        penerimaan. Kami akan berusaha untuk memastikan bahwa negara yang menjadi tujuan dari transfer Informasi
        Pribadi Anda memiliki undang-undang perlindungan Informasi Pribadi yang serupa atau setara.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >Your Personal Information may be transferred across borders by Us in accordance with applicable laws and
        where there is a lawful basis for Us doing so (such as the performance of a contract between You and Us, Your
        consent, and/or Our legal or regulatory obligation). Your Personal Information may be transferred with any
        member of Our group located in different countries. We will take reasonably appropriate measures to maintain
        the security of the Personal Information both during transit and at the receiving location. We will strive to
        ensure that the country Your Personal Information is transferred to has a similar or equivalent Personal
        Information protection laws in place.</span
      >
    </p>
    <p class="c15 c8">
      <span class="c5">PENGAMBILAN KEPUTUSAN SECARA OTOMATIS, KECERDASAN BUATAN, DAN PROFILING &ndash; </span
      ><span class="c5 c39 c22 c25">AUTOMATED DECISIONS, ARTIFICIAL INTELLIGENCE USE AND PROFILING</span>
    </p>
    <p class="c1">
      <span class="c3"
        >3.8 Sebagai bagian dari penyediaan produk dan layanan Kami, Kami menggunakan kecerdasan buatan dan pembuatan
        profil termasuk analisis perilaku, untuk memverifikasi identitas Anda melalui proses &ldquo;kenali klien
        Anda&rdquo; secara elektronik dan pengambilan swafoto Anda secara langsung, untuk membuat keputusan risiko
        kredit dan untuk mencegah pencucian uang, terorisme, penipuan dan kejahatan keuangan lainnya. Jika Anda tidak
        setuju dengan penggunaan Informasi Pribadi Anda untuk tujuan tersebut oleh Kami, Anda dapat mengirimkan
        permintaan tertulis kepada Kami. Harap dicatat jika Anda ingin menolak penggunaan Informasi Pribadi Anda
        dengan cara ini, Kami mungkin tidak dapat melanjutkan penawaran produk dan layanan Kami kepada Anda, dalam hal
        ini Kami mungkin perlu mengakhiri hubungan Kami untuk memenuhi permintaan Anda.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >As part of providing Our product and services, We use artificial intelligence and profiling including
        behavioural analysis, to verify Your identity through Our electronic &ldquo;know Your client&rdquo; processes
        and the capture of Your live selfie, to make credit-risk decisions and to prevent money laundering, terrorism,
        fraud and other financial crime. &nbsp;If You do not agree with Us using Your Personal Information for such
        purposes, You can send a written request to Us. Please note should You wish to object the usage of Your
        Personal Information in this way, We may not be able to continue to offer You Our products and services, in
        which case We may need to terminate Our relationship in order to fulfil Your request.</span
      >
    </p>
    <p class="c15 c8">
      <span class="c5"
        >PERSETUJUAN DAN PENCABUTAN PERSETUJUAN TERKAIT PENGGUNAAN INFORMASI TERTENTU OLEH KAMI &ndash; </span
      ><span class="c5 c39 c22 c25">CONSENT AND WITHDRAWING CONSENT FOR US TO USE CERTAIN INFORMATION</span>
    </p>
    <p class="c1">
      <span class="c3"
        >3.9 Anda dapat menarik persetujuan Anda untuk pengumpulan, penggunaan dan/atau pengungkapan Informasi Pribadi
        Anda yang kami miliki atau berada di bawah kendali Kami untuk tujuan tertentu dengan menghubungi
        cs@kreditpintar.com. Namun, hal ini dapat memengaruhi kemampuan Kami untuk memberi Anda layanan seperti
        melakukan transaksi yang diminta oleh Anda di situs web atau situs web/portal TI/aplikasi seluler Kami. Mohon
        diperhatikan bahwa sehubungan dengan aktivitas pemrosesan yang penting untuk pelaksanaan kontrak Kami dengan
        Anda, Anda mungkin tidak dapat menggunakan hak ini kecuali jika Anda ingin mengakhiri kontrak Anda dengan
        Kami.</span
      >
    </p>
    <p class="c6">
      <span class="c25"
        >You may withdraw Your consent for the collection, use and/or disclosure of Your Personal Information in Our
        possession or under Our control for certain purposes by contacting </span
      ><span class="c45 c25">cs@kreditpintar.com</span
      ><span class="c4"
        >. However, this may affect Our ability to provide You with services such as to perform the transactions
        requested by You on Our website(s) or website/IT portal(s)/mobile application(s). Do note that in relation to
        the processing activities that are essential to the performance of Our contract with You, You may not be able
        to exercise this right unless You wish to terminate Your contract with Us.</span
      >
    </p>
    <p class="c1">
      <span class="c3"
        >3.10 Kami dapat mengumpulkan, menggunakan, mengungkapkan, atau memproses Informasi Pribadi Anda untuk tujuan
        lain yang tidak disebutkan di atas. Namun, Kami akan memberi tahu Anda tentang tujuan lain tersebut pada saat
        mendapatkan persetujuan Anda, kecuali pemrosesan Informasi Pribadi Anda tanpa persetujuan Anda diizinkan oleh
        UU PDP atau oleh undang-undang yang berlaku.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >We may collect, use, disclose or process Your Personal Information for other purposes that do not appear
        above. However, We will notify You of such other purpose at the time of obtaining Your consent, unless
        processing of Your Personal Information without Your consent is permitted by the PDP Law or by any applicable
        law.</span
      >
    </p>
    <p class="c1">
      <span class="c3"
        >3.11 Sejauh diizinkan oleh undang-undang yang berlaku, Kami dapat mengumpulkan, menggunakan, mengungkapkan,
        atau memproses Informasi Pribadi Anda untuk salah satu tujuan berikut tanpa persetujuan Anda:</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >To the extent permitted by applicable laws, We may collect, use, disclose or process Your Personal
        Information for any of the following purposes without Your consent:</span
      >
    </p>
    <p class="c2 c10 c8">
      <span class="c3">i. jika diperlukan untuk mematuhi hukum yang berlaku bagi Kami;</span>
    </p>
    <p class="c15 c8 c38">
      <span class="c4">if it is necessary for compliance with laws to which We are subjected;</span>
    </p>
    <p class="c15 c26 c8">
      <span class="c3"
        >ii. untuk mencegah atau menangguhkan bahaya terhadap kehidupan, tubuh atau kesehatan seseorang;</span
      >
    </p>
    <p class="c15 c8 c38">
      <span class="c4">if it is in order to prevent or suspend danger to life, body or health of a person;</span>
    </p>
    <p class="c15 c26 c8">
      <span class="c3"
        >iii. untuk memenuhi kontrak yang mana Anda menjadi salah satu pihak atau untuk memenuhi permintaan Anda
        sebelum pelaksanaan kontrak;</span
      >
    </p>
    <p class="c15 c8 c38">
      <span class="c4"
        >if it is in order to comply with the contract to which You are a party or in order to comply with Your
        request prior to execution of the contract;</span
      >
    </p>
    <p class="c15 c26 c8">
      <span class="c3"
        >iv. untuk memenuhi kewajiban Kami dalam melakukan tindakan untuk kepentingan umum atau untuk memenuhi
        kewajiban menjalankan kekuasaan negara yang diberikan kepada Kami;</span
      >
    </p>
    <p class="c15 c8 c38">
      <span class="c4"
        >if it is in order for Us to comply with the duty to take actions for public benefit or to comply with the
        duty to exercise state power conferred on Us;</span
      >
    </p>
    <p class="c15 c8 c26">
      <span class="c3"
        >v. untuk mencapai kepentingan yang sah dari Kami atau ailiasi Kami atau orang lain kecuali kepentingan
        tersebut memiliki bobot yang lebih kecil dari hak dasar Anda dalam Informasi Pribadi; atau</span
      >
    </p>
    <p class="c15 c8 c38">
      <span class="c4"
        >if it is in order to achieve legitimate interests of Us or Our affiliates or other persons unless such
        interest has less weight than Your basic right in the Personal Information; or</span
      >
    </p>
    <p class="c15 c26 c8">
      <span class="c3"
        >vi. jika diizinkan oleh atau jatuh dalam keadaan apa pun yang ditentukan oleh undang-undang yang berlaku
        termasuk undang-undang privasi data yang berlaku.</span
      >
    </p>
    <p class="c15 c8 c38">
      <span class="c4"
        >if it is permitted by or falls under any circumstances prescribed by any applicable laws including the
        applicable data privacy laws.</span
      >
    </p>
    <p class="c1">
      <span class="c3"
        >3.12 Kami mungkin/akan juga mengumpulkan dari sumber selain Anda (termasuk sumber yang tercantum dalam Pasal
        3) Informasi Pribadi tentang Anda, untuk satu atau lebih tujuan di atas, dan setelah itu menggunakan,
        mengungkapkan, dan/atau memproses Informasi Pribadi tersebut untuk satu atau lebih dari tujuan di atas. Kami
        dapat menggabungkan informasi yang Kami terima dari sumber lain dengan informasi yang Anda berikan kepada Kami
        dan informasi yang Kami kumpulkan tentang Anda. Kami dapat menggunakan informasi ini dan informasi gabungan
        untuk tujuan yang ditetapkan di atas (tergantung pada jenis informasi yang Kami terima).</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >We may/will also be collecting from sources other than Yourself (including sources listed in Clause 3)
        Personal Information about You, for one or more of the above purpose, and thereafter using, disclosing and/or
        processing such Personal Information for one or more of the above purpose. We may combine information We
        receive from other sources with information You give to Us and information We collect about You. We may use
        this information and the combined information for the purpose set out above (depending on the types of
        information We receive).</span
      >
    </p>
    <p class="c15 c8">
      <span class="c5">KETEPATAN DAN KEASLIAN INFORMASI PRIBADI &ndash; </span>
      <span class="c5 c39 c22 c25">ACCURACY AND AUTHENTICITY OF PERSONAL INFORMATION</span>
    </p>
    <p class="c1">
      <span class="c3"
        >3.13 Dengan memberikan Kami Informasi Pribadi Anda, Anda menjamin bahwa itu benar, akurat dan asli dan Anda
        berjanji untuk memberi tahu Kami sesegera mungkin tentang setiap perubahan atau pergantian terhadap Informasi
        Pribadi Anda. Setiap kehilangan atau kerusakan yang disebabkan oleh pemberian informasi yang salah, tidak
        akurat atau tidak lengkap akan menjadi tanggung jawab eksklusif dan mutlak Anda. &nbsp; Atas setiap pemalsuan
        Informasi Pribadi, dokumen atau tindak pidana lain yang dilakukan oleh Anda, Kami berhak melakukan upaya hukum
        termasuk memproses tindakan yang dimaksud kepada pihak yang berwenang.
      </span>
    </p>
    <p class="c6">
      <span class="c25">
        By providing Us with Your Personal Information, You warrant that it is true, accurate and authentic and
        undertake to notify Us as soon as practicable of any change or alteration to the same. Any loss or damage
        caused by the provision of erroneous, inaccurate or incomplete information will be Your exclusive and absolute
        responsibility. For any falsification of Personal Information, documents, or other criminal acts committed by
        You, We reserve the right to take legal action, including pursuing the intended actions with the appropriate
        authorities.
      </span>
    </p>
    <p class="c15 c8">
      <span class="c5 c24 c22">PENYIMPANAN INFORMASI PRIBADI &ndash; PERSONAL INFORMATION STORAGE</span>
    </p>
    <p class="c1">
      <span class="c3"
        >3.14 Semua Informasi Pribadi yang Anda berikan dan/atau Kami terima sesuai dengan Kebijakan Privasi disimpan
        dengan aman di wilayah Republik Indonesia dan apabila Informasi Pribadi tersebut dikirim ke luar wilayah
        Republik Indonesia, pengiriman tersebut akan dilakukan sesuai dengan syarat dan ketentuan peraturan perundang-
        undangan yang berlaku. &nbsp;Kami juga akan mengambil langkah-langkah yang wajar untuk melindungi data Anda
        selama transfer dan penyimpanan; langkah-langkahnya dapat mencakup memperoleh persetujuan Anda, menerapkan
        perlindungan kontraktual, dan mengandalkan mekanisme transfer lain yang diakui secara hukum.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >All Personal Information that You provide and/or that We receive in accordance with this Privacy Policy is
        stored within the territory of the Republic of Indonesia and if transferred outside the territory of the
        Republic of Indonesia, such transfer will be made in accordance with requirements set out under the prevailing
        laws and regulations.We will also take reasonable steps to safeguard Your data during transfers and storage;
        steps may include obtaining Your consent, implementing contractual safeguards and relying on other transfer
        mechanisms that are legally recognized.</span
      >
    </p>
    <p class="c1">
      <span class="c3"
        >3.15 Kami akan menyimpan Informasi Pribadi Anda setidaknya selama 5 (lima) tahun atau selama diperlukan untuk
        melindungi kepentingan Kami atau sebagaimana dipersyaratkan oleh peraturan perundang-undangan Indonesia.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >We will store Your Personal Information for at least 5 (five) years as required by Indonesian laws and
        regulations.</span
      >
    </p>
    <p class="c15">
      <span class="c5 c22 c24">KEAMANAN INFORMASI PRIBADI &ndash; SECURITY OF PERSONAL INFORMATION</span>
    </p>
    <p class="c1">
      <span class="c3"
        >3.16 Kami akan mengambil semua langkah dan tindakan yang wajar untuk mencegah kehilangan, penyalahgunaaan
        atau perubahan Informasi Pribadi Anda tanpa izin oleh pihak-pihak yang tidak berwenang.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >We will take all reasonable steps and actions to prevent the loss, misuse or unauthorized changes of Your
        Personal Information by unauthorized parties.</span
      >
    </p>
    <p class="c1">
      <span class="c3"
        >3.17 Terlepas dari langkah dan tindakan pencegahan yang Kami lakukan, pemasukan atau penggunaan tanpa izin,
        serta kegagalan perangkat keras atau lunak, dapat terjadi dan mengganggu keamanan dari Informasi Pribadi Anda.
        Sehubungan dengan hal-hal tersebut Kami dengan ini memberikan disclaimer bahwa, sepanjang sepenuhnya
        diperbolehkan oleh hukum, setiap tanggung jawab atau tanggungan langsung maupun tidak langsung yang timbul
        dari atau sehubungan dengan setiap kerugian, pencurian, atau pengaksesan tanpa izin, pengambilan, penggunaan,
        pengungkapan, penyalinan, modifikasi, penghilangan atau tindakan serupa berkenaan dengan Informasi Pribadi
        yang diberikan oleh Anda kepada Kami.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >Whilst We take necessary steps and precautionary actions to prevent unauthorized entry or &nbsp;use, and
        hardware or software failure, these situations may happen and potentially compromise the security of Your
        Personal Information. We hereby disclaim, to the fullest extent permissible by law, any responsibility or
        liability directly or indirectly arising out of or in connection with, any loss, theft, or unauthorized
        access, collection, use, disclosure, copying, modification, disposal or similar actions with regard to any
        Personal Information provided by You to Us.</span
      >
    </p>
    <p class="c1">
      <span class="c3"
        >3.18 Saat mendaftarkan diri di Platform, Anda diminta untuk membuat kata sandi pribadi Anda sendiri. Anda
        bertanggung jawab untuk menjaga kerahasiaan kata sandi tersebut. Anda diminta untuk tidak membagikan kata
        sandi Anda kepada pihak manapun.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >When registering yourself on the Platform, You are requested to create Your own personal password. You are
        responsible for maintaining the confidentiality of this password. You should not share Your password with
        anyone.</span
      >
    </p>
    <p class="c15 c9">
      <span class="c5">PENGEMBALIAN DAN PEMUSNAHAN INFORMASI PRIBADI &ndash; </span
      ><span class="c5 c25">RETURNING AND</span><span class="c12">&nbsp;</span
      ><span class="c5 c22 c25 c39">DESTRUCTION OF PERSONAL INFORMATION</span>
    </p>
    <p class="c1">
      <span class="c3">3.19 Informasi Pribadi Anda hanya dapat dimusnahkan jika:</span>
    </p>
    <p class="c6">
      <span class="c4">Your Personal Information can only be destroyed if:</span>
    </p>
    <p class="c2 c10">
      <span class="c3"
        >(a) Informasi Pribadi Anda telah disimpan selama 5 (lima) tahun setelah berakhirnya hubungan bisnis Anda
        dengan Kami atau sesuai dengan ketentuan peraturan perundang-undangan perlu dihapus; atau</span
      >
    </p>
    <p class="c2 c9">
      <span class="c4"
        >Your Personal Information has been stored for 5 (five) years since the end of Your business relationship with
        Us or is required to be destroyed in accordance with the prevailing laws and regulations; or</span
      >
    </p>
    <p class="c2 c8 c10">
      <span class="c3"
        >(b) atas permintaan Anda, kecuali Kami dipersyaratkan untuk menyimpannya sesuai dengan ketentuan peraturan
        perundang-undangan.</span
      >
    </p>
    <p class="c2 c9">
      <span class="c4"
        >You request, unless We are required to retain such Personal Information in accordance with the prevailing
        laws and regulations.</span
      >
    </p>
    <p class="c1">
      <span class="c3"
        >3.20 Pemusnahan Informasi Pribadi sebagaimana pada Pasal 3.11 termasuk menghilangkan sebagian atau
        keseluruhan dokumen terkait Informasi Pribadi Anda yang Kami simpan sehingga Informasi Pribadi tersebut tidak
        dapat ditampilkan kembali dalam sistem elektronik Kami kecuali Anda memberikan Informasi Pribadi yang baru
        kepada Kami.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >Destruction of Personal Information as referred to in Article 3.11 includes removing part or all of the
        documents related to Your Personal Information that We hold so that the Personal Information cannot be
        re-displayed in Our electronic system unless You provide new Personal Information to Us.</span
      >
    </p>
    <p class="c15">
      <span class="c5">PERUBAHAN INFORMASI PRIBADI &ndash; </span
      ><span class="c5 c39 c22 c25">THE CHANGE OF PERSONAL INFORMATION</span>
    </p>
    <p class="c1">
      <span
        >3.21 Kami memahami bahwa Anda perlu memperbarui atau mengubah Informasi Pribadi Anda dari waktu ke waktu.
        Jika Anda perlu memperbarui atau mengubah Informasi Pribadi, maka Anda dapat mengajukan permohonan secara
        tertulis via surat elektronik (e-mail) kepada Kami ke </span
      ><span class="c45">cs@kreditpintar.com</span
      ><span class="c3"
        >&nbsp;dan berikan Kami rincian yang relevan. Kami akan membantu memperbarui dan/atau memperbaiki Informasi
        Pribadi Anda untuk Anda jika dianggap perubahan tersebut diperlukan.</span
      >
    </p>
    <p class="c6">
      <span class="c25"
        >We understand that You need to update or amend Your Personal Information from time to time. If You need to
        update or amend Your Personal Information, You can submit a written request via e-mail to Us at </span
      ><span class="c25 c61">cs@kreditpintar.com</span
      ><span class="c4"
        >&nbsp;and provide Us with the relevant details. We will help to update and/or correct Your Personal
        Information for You if it is deemed necessary.</span
      >
    </p>
    <p class="c15 c9">
      <span class="c5">PENGEMBALIAN DAN PENGHAPUSAN INFORMASI PRIBADI &ndash;</span
      ><span class="c5 c25">&nbsp;RETURN AND</span><span class="c12">&nbsp;</span
      ><span class="c5 c39 c22 c25">REMOVAL OF PERSONAL INFORMATION</span>
    </p>
    <p class="c1">
      <span class="c3">3.22 Anda berhak atas pengembalian Informasi Pribadi dengan persyaratan bahwa Anda:</span>
    </p>
    <p class="c15 c16">
      <span class="c4">You are entitled to request the return of Your Personal Information provided that:</span>
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(a) tidak sedang terikat perjanjian sehubungan dengan penyediaan Layanan pada Platform, baik Perjanjian
        Penyaluran Pendanaan maupun Perjanjian Pendanaan;</span
      >
    </p>
    <p class="c2 c8">
      <span class="c25"
        >You are not currently bound by an agreement in connection with the provision of Services of the Platform such
        as the Loan Distribution Agreement and the Loan Agreemen</span
      ><span class="c3">t;</span>
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(b) tidak memiliki hak sehubungan dengan penyediaan Layanan pada Platform, termasuk namun tidak terbatas pada
        hak tagih atas pengembalian, pembayaran kembali dan pelunasan piutang;</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >You have no right in connection with the provision of Services on the Platform, including but not limited to
        the right to collect for the return, repayment and payment of receivables;</span
      >
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(c) tidak memiliki kewajiban, tanggung jawab finansial, utang atau hal sejenisnya sehubungan dengan
        penyediaan Layanan pada Platform;</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >You have no obligation, financial responsibility, debt or similar matters in connection with the provision of
        Services on the Platform;</span
      >
    </p>
    <p class="c2 c10">
      <span class="c3"
        >(d) tidak dalam proses pengajuan Permohonan Pendanaan, atau sedang menjalani verifikasi dan penilaian
        terhadap permohonan tersebut oleh Kami; dan</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >You are not in the process of submitting a Loan Application, or undergoing verification and evaluation of the
        application by Us; and</span
      >
    </p>
    <p class="c2 c10">
      <span class="c3">(e) tidak terdaftar sebagai Pengguna aktif Platform (akun Pengguna sudah dinonaktifkan).</span>
    </p>
    <p class="c2 c8">
      <span class="c4">You are not registered as an active Platform User (User account has been deactivated).</span>
    </p>
    <p class="c1">
      <span class="c3"
        >3.23 Permohonan pengembalian Informasi Pribadi tersebut disampaikan kepada Kami melalui surat elektronik
        (e-mail) cs@kreditpintar.com dengan menyertakan bukti diri yang sah (salinan kartu tanda penduduk atau paspor)
        beserta alasan perlunya pengembalian Informasi Pribadi.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >The request for the return of Personal Information shall be sent to Us via e-mail at cs@kreditpintar.com by
        attaching Your valid proof of identity (copy of resident card or passport).</span
      >
    </p>
    <p class="c1">
      <span class="c3"
        >3.24 Anda berhak memohonkan penghapusan Informasi Pribadi yang Kami simpan dengan memberikan pemberitahuan
        secara tertulis paling lambat 10 (sepuluh) hari kerja sebelum tanggal penghapusan yang dikehendaki dengan
        menyebutkan jenis atau wujud Informasi Pribadi yang dimohonkan penghapusannya. Ketentuan penghapusan Informasi
        Pribadi ini harus dilaksanakan sesuai dengan ketentuan Perkominfo No. 20/2016.</span
      >
    </p>
    <p class="c6">
      <span class="c25"
        >You have the right to request the deletion of Personal Information that We hold by giving at least 10 (ten)
        working days written notice before the proposed date of deletion by stating the type or form of Personal
        Information requested for deletion. Provisions for the elimination of this Personal Information must be
        carried out in accordance with the provisions of Perkominfo No. 20/2016.</span
      >
    </p>
    <p class="c15 c31"><span class="c14 c44 c20">&nbsp;</span></p>
    <p class="c29"><span class="c20">PASAL 4 &ndash; </span><span class="c14 c12">ARTICLE 4</span></p>
    <p class="c19">
      <span class="c20">PENGGUNAAN KONTAK TERDAFTAR &ndash; </span
      ><span class="c14 c12">THE USAGE OF REGISTERED CONTACT</span>
    </p>
    <h1 class="c15 c8" id="h.2y3ven8fwwtz">
      <span class="c5 c22">TUJUAN PENGGUNAAN KONTAK TERDAFTAR &ndash; </span
      ><span class="c5 c39 c22 c25">THE FUNCTION OF THE REGISTERED CONTACT</span>
    </h1>
    <p class="c1">
      <span
        >4.1 Kontak Terdaftar yang diberikan oleh Penerima Dana saat proses pengajuan permohonan perolehan Pendanaan
        (&ldquo;</span
      ><span class="c20">Permohonan Pendanaan</span
      ><span class="c3"
        >&rdquo;) akan digunakan khusus untuk menghubungi Kontak Terdaftar ketika Penerima Dana diklasifikasikan
        sebagai Gagal Bayar.</span
      >
    </p>
    <p class="c6">
      <span class="c25"
        >The Registered Contact provided by the Borrower during the process of submitting the Loan application
        (&quot;</span
      ><span class="c12">Loan Application</span
      ><span class="c25"
        >&quot;) will be used for contacting the Registered Contact when the Borrower is classified as being in
        Failure of Payment</span
      ><span class="c3">.</span>
    </p>
    <p class="c15 c9">
      <span class="c5">HAK KAMI MENGHUBUNGI KONTAK TERDAFTAR &ndash;</span
      ><span class="c5 c39 c22 c25">&nbsp;OUR RIGHTS OF TO CONTACT THE REGISTERED CONTACT</span>
    </p>
    <p class="c1">
      <span class="c3"
        >4.2 Sebagai syarat mutlak dari Pendanaan yang dilakukan melalui Platform, Penerima Dana dengan ini
        mengizinkan Kami, dan menyatakan bahwa pihaknya telah mendapatkan persetujuan terlebih dahulu dari Kontak
        Terdaftar tetapi tanpa memerlukan persetujuan lebih lanjut dari pihak lain manapun, untuk menghubungi Kontak
        Terdaftar dalam hal Penerima Dana diklasifikasikan sebagai Gagal Bayar, untuk tujuan sebagai berikut:</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >As an absolute requirement for a Loan to be made through the Platform, the Borrower hereby authorizes Us, and
        represents that it has obtained prior consent from the Registered Contact but without requiring further
        approval of any other party, to contact the Registered Contact in the event that the Borrower is classified as
        being in Failure of Payment, for the following purposes:</span
      >
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(a) mencari atau menelusuri keberadaaan Penerima Dana dalam hal Penerima Dana yang belum melunasi Pendanaan
        dan Penerima Dana tidak bisa atau sulit dihubungi melalui nomor telepon selular Penerima Dana yang terdaftar
        yang tercatat pada Platform pada saat proses pengajuan Permohonan Pendanaan;</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >to search or track the location of the Borrower in the event that the Borrower has not paid the Loan and the
        Borrower cannot be contacted at his/her registered cellular telephone number recorded with the Platform during
        the Loan Application process;</span
      >
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(b) meminta bantuan Kontak Terdaftar untuk mengingatkan Penerima Dana untuk membayar dan melunasi Pendanaan;
        dan/atau</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >to request assistance from the Registered Contact to remind the Borrower to pay and settle the Loan;
        and/or</span
      >
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(c) meminta Kontak Terdaftar menyampaikan pesan dari Kami sehubungan dengan pemenuhan kewajiban pelunasan
        Pendanaan dan Gagal Bayar.</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >to request the Registered Contact to deliver the message from Us in connection with the fulfillment of the
        Loan repayment obligation and the Failure of Payment.</span
      >
    </p>
    <p class="c6">
      <span class="c3"
        >Kami akan menghubungi Kontak Terdaftar untuk tujuan di atas baik melalui, antara lain, telepon langsung, SMS
        (Short Message Service), Whatsapp, dan/atau carakomunikasi lain sebagaimana ditentukan oleh Kami dari waktu ke
        waktu dengan tetap memperhatikan ketentuan hukum yang berlaku.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >We shall contact the Registered Contact for the above purpose either through direct calls, SMS (Short Message
        Service), Whatsapp and/or other communication methods as determined by Us from time to time with due obervance
        to the provisions of the prevailing laws.</span
      >
    </p>
    <p class="c15 c8 c48"><span class="c3">&nbsp;</span></p>
    <p class="c11">
      <span class="c5">PEMBEBASAN TANGGUNG JAWAB KAMI</span
      ><span class="c5 c39 c22 c25">&nbsp;&ndash; RELEASE OF OUR LIABILITY</span>
    </p>
    <p class="c1">
      <span class="c3"
        >4.3 Penerima Dana dengan ini akan membebaskan, membela dan memberi ganti rugi kepada Kami dan/atau Pemberi
        Dana (berikut karyawan, direksi, komisaris, pemegang saham, perwakilan, kuasa, agen dan/atau afiliasinya Kami
        dan Pemberi Pinajam) dari setiap kerugian, pengeluaran, ongkos maupun biaya yang timbul dari atau sehubungan
        dengan:</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >The Borrower hereby releases, defends and indemnifies Us and the Lender (along with Our and the
        Lender&rsquo;s employees, directors, commissioners, shareholders, representatives, attorneys, agents and/or
        affiliates) from any claims, liabilities, losses, expenses, costs or fees arising from or in connection with
        the following:</span
      >
    </p>
    <p class="c2 c10">
      <span class="c3"
        >(a) sengketa dengan pihak ketiga terkait Kontak Terdaftar oleh karena alasan sengketa apapun;</span
      >
    </p>
    <p class="c15 c28 c57">
      <span class="c4">any dispute with a third party regarding a Registered Contact for any reason;</span>
    </p>
    <p class="c2 c10">
      <span class="c3"
        >(b) pelanggaran hak atau kerugian pihak ketiga atau pihak manapun terkait Kontak Terdaftar; dan</span
      >
    </p>
    <p class="c2">
      <span class="c4"
        >violation of rights or losses of third parties or any parties related to the Registered Contact; and</span
      >
    </p>
    <p class="c2 c10">
      <span class="c3"
        >(c) sanksi, investigasi atau penyelidikan, penyidikan, inspeksi atau audit maupun konsekuensi apapun dari
        atau terkait pelanggaran ketentuan hukum dan/atau peraturan perundang-undangan, kebijakan pemerintah dan/atau
        putusan badan peradilan atau arbitrase manapun akibat dari atau sehubungan dengan pelaksanaan hak Kami dalam
        ketentuan ini atau upaya menghubungi, mengakses, menelusuri, memperoleh dan/atau memanfaatkan Kontak
        Terdaftar.</span
      >
    </p>
    <p class="c2">
      <span class="c4"
        >sanctions, research, investigations, inspections or audits as well as any consequences of or relating to
        violations of legal provisions and/or legislation, government policies and/or judicial and/or arbitration
        decision resulting from or in connection with the implementation of Our rights herein or attempts to contact,
        access, browse, obtain and/or utilize a Registered Contact.</span
      >
    </p>
    <p class="c15 c28"><span class="c3">&nbsp;</span></p>
    <p class="c29"><span class="c20">PASAL 5 &ndash; </span><span class="c14 c12">ARTICLE 5</span></p>
    <p class="c49"><span class="c20">HAK PENGGUNA &ndash; </span><span class="c14 c12">USERS RIGHTS</span></p>
    <p class="c15 c16 c10">
      <span class="c3">5.1 Sehubungan dengan penggunaan Layanan pada Platform, Pengguna berhak:</span>
    </p>
    <p class="c15 c16">
      <span class="c4">In connection with the use of the Services on the Platform, You are entitled:</span>
    </p>
    <p class="c2 c10">
      <span class="c3">(a) atas kerahasiaan Informasi Pribadinya dan Kontak Terdaftar;</span>
    </p>
    <p class="c2">
      <span class="c4">to the confidentiality of Your Personal Information and the Registered Contact;</span>
    </p>
    <p class="c2 c10">
      <span class="c3"
        >(b) mengajukan pengaduan dalam rangka kegagalan Kami dalam melakukan perlindungan Informasi Pribadi kepada
        pihak yang berwenang sesuai dengan peraturan perundang-undangan yang berlaku;</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >to submit a complaint in the context of Our failure to protect the Personal Information to the relevant
        authorized agencies in accordance with the prevailing laws and regulations;</span
      >
    </p>
    <p class="c2 c10">
      <span class="c3"
        >(c) mendapatkan akses atau untuk mengubah atau memperbaharui Informasi Pribadinya, kecuali ditentukan lain
        oleh ketentuan peraturan perundang- undangan;</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >to obtain access to, change or update Your Personal Information, unless otherwise specified in the laws and
        regulations;</span
      >
    </p>
    <p class="c2 c10">
      <span class="c3"
        >(d) mendapatkan akses atau untuk memperoleh historis Informasi Pribadinya yang pernah diserahkan kepada Kami
        sepanjang masih sesuai dengan ketentuan peraturan perundang-undangan yang berlaku;</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >to obtain access to Your historical Personal Information that has been submitted to Us in accordance with the
        prevailing laws and regulations;</span
      >
    </p>
    <p class="c2 c10">
      <span class="c3"
        >(e) meminta pemusnahan Informasi Pribadi yang yang Kami kelola, kecuali ditentukan lain oleh ketentuan
        peraturan perundang-undangan yang berlaku; dan</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >to request the destruction of Personal Information that We manage, unless specified otherwise in the
        prevailing laws and regulations;
      </span>
    </p>
    <p class="c2 c10">
      <span class="c3">(f) untuk menolak pembuatan keputusan secara otomatis dan profiling;</span>
    </p>
    <p class="c2">
      <span class="c4">to object to automated decision making and profiling;</span>
    </p>
    <p class="c2 c10">
      <span class="c3"
        >(g) untuk menerima informasi terkait penggunaan dan pengungkapan Informasi Pibadi Anda dalam tujuan
        sebagaimana disebutkan dalam Kebijakan Privasi ini;</span
      >
    </p>
    <p class="c2">
      <span class="c4"
        >to obtain information about the usage and disclosure of Your Personal Information in the purposes described
        in this Privacy Policy;</span
      >
    </p>
    <p class="c2 c10">
      <span class="c3"
        >(h) untuk menerima Informasi Pribadi Anda yang disediakan kepada Kami dan berhak untuk mengirim data tersebut
        ke organisasi lainnya (atau meminta Kami untuk mengirimkannya apabila dimungkinkan secara teknis;</span
      >
    </p>
    <p class="c2">
      <span class="c4"
        >to receive Your Personal Information provided to Us and the right to send the data to another organization
        (or ask Us to do so if technically feasible);</span
      >
    </p>
    <p class="c2 c10">
      <span class="c3">(i) untuk menunda atau membatasi pemrosesan Informasi Pribadi Anda; dan</span>
    </p>
    <p class="c2">
      <span class="c4">to delay or limit the processing of Your Personal Information; and</span>
    </p>
    <p class="c2 c10">
      <span class="c3"
        >(j) untuk menolak menerima penawaran atas produk dan layanan Kami, atau produk dan layanan yang mungkin
        menarik bagi Anda.</span
      >
    </p>
    <p class="c2">
      <span class="c4"
        >to opt out of receiving offers for Our products and services, or products and services that may be of
        interest to You.</span
      >
    </p>
    <p class="c15 c16">
      <span>Anda dapat menggunakan hak pengguna di atas dengan menghubungi Kami melalui email di </span
      ><span class="c45">cs@kreditpintar.com</span
      ><span class="c3"
        >. Kami akan menggunakan upaya terbaik kami untuk menyelesaikan permintaan anda sesuai jangka waktu
        sebagaimana ditentukan berdasarakan UU PDP. Apabila kami tetap tidak dapat memenuhi jangka waktu tersebut,
        kami akan menyediakan penjelasan yang sesuai mengenai alas an kami tidak dapat memenuhi permintaan anda dalam
        jangka waktu yang telah ditentukan dan menyediakan jangka waktu yang baru.</span
      >
    </p>
    <p class="c15 c16">
      <span class="c25">You are able to exercise the above user rights by contacting Us via e-mail at </span
      ><span class="c45 c25">cs@kreditpintar.com. &nbsp;</span
      ><span class="c4"
        >We will put our best efforts to resolve your request as per the timelines provided under the new PDP Law. In
        case we are unable to meet the timelines, we will provide appropriate explanation on why we are unable to
        fulfill your request within the stipulated timelines and provide new timelines.</span
      >
    </p>
    <p class="c2"><span class="c3">&nbsp;</span></p>
    <p class="c29"><span class="c20">PASAL 6 &ndash; </span><span class="c14 c12">ARTICLE 6</span></p>
    <p class="c19">
      <span class="c20">KEGAGALAN MENJAGA INFORMASI PRIBADI &ndash; </span
      ><span class="c14 c12">FAILURE IN PROTECTING PERSONAL INFORMATION</span>
    </p>
    <p class="c15 c16 c10">
      <span class="c3"
        >6.1 Anda setuju untuk tidak meminta pertanggungjawaban Kami atas pelanggaran, atau ketidakpatuhan terhadap
        Kebijakan Privasi atau perlindungan Informasi Pribadi dalam situasi berikut:</span
      >
    </p>
    <p class="c15 c16 c9">
      <span class="c3"
        >You agree not to seek Our responsibility for violations, or non-compliance with the Privacy Policy or the
        protection of Personal Information in the following situations:</span
      >
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(a) Dimana suatu tindakan alam atau keadaan yang tidak terduga telah terjadi, mengakibatkan kerusakan atau
        penghancuran peralatan dan/atau sistem yang digunakan untuk mengamankan, menyimpan atau memproses Informasi
        Pribadi Pengguna;</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >Where an act of nature or an unexpected situation has occurred, resulting in damage or destruction of
        equipment and/or systems which are used to secure, store or process a User&#39;s Personal Information;</span
      >
    </p>
    <p class="c2 c10">
      <span class="c3"
        >(b) Dimana Informasi Pribadi telah tersedia atau dapat ditemukan oleh publik sebelum Informasi Pribadi
        tersebut disampaikan kepada Kami;</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >Where Personal Information is available or can be found by the public before such Personal Information has
        been conveyed by Us;</span
      >
    </p>
    <p class="c2 c10">
      <span class="c3"
        >(c) Dimana Kami telah memberikan upaya terbaik untuk memverifikasi, mengamankan dan melindungi Informasi
        Pribadi, dan dalam hal terdapat akses yang tidak sah, hacking, penyalahgunaan, modifikasi, perubahan,
        gangguan;</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >Where We have given Our best effort and to verify, secure and protect the Personal Information, and in the
        event of any unauthorized access, hacking, misuse, modification, change, interference;</span
      >
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(d) Atas keakurasian (kecuali Informasi Pribadi yang telah diverifikasi oleh Kami sesuai kebijakannya),
        keabsahan, legalitas dan kelengkapan Informasi Pribadi Anda; dan/atau</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >For the accuracy (unless for Personal Information that has been verified by Us at its Our discretion),
        validity, legality and completeness of Your Personal Information; and/or</span
      >
    </p>
    <p class="c2 c10">
      <span class="c3"
        >(e) Dimana penyalahgunaan Informasi Pribadi dan informasi yang disebabkan dengan tindakan kejahatan, penipuan
        atau tindak pidana apapun atau salah tindakan dari pihak ketiga yang tidak berada di bawah kendali atau
        instruksi Kami.</span
      >
    </p>
    <p class="c2 c8">
      <span class="c4"
        >Where the misuse of Personal Information and information caused by acts of crime, fraud or any criminal act
        or illegal action of a third party that is not under Our control or instruction.</span
      >
    </p>
    <p class="c1">
      <span class="c3"
        >6.2 Kami akan berupaya sewajarnya untuk memberitahu secara tertulis melalui surat elektronik (e-mail) kepada
        Anda jika terjadi kegagalan perlindungan rahasia Informasi Pribadi dalam pengelolaan Platform baik yang
        disebabkan oleh Kami atau ketika Kami mengetahuinya dari pihak ketiga, dengan ketentuan pemberitahuan sebagai
        berikut:</span
      >
    </p>
    <p class="c6">
      <span class="c3"
        >We will give Our reasonable efforts to notify You in writing via e-mail if there is a failure of Our
        protection of Personal Information during the management of the Platform, whether occurred due to Us or a
        third party, with the following notification conditions:</span
      >
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(a) dengan menyertakan alasan atau penyebab terjadinya kegagalan perlindungan rahasia Informasi
        Pribadi;</span
      >
    </p>
    <p class="c2 c9">
      <span class="c3">by including the reason or cause of failure of the protection of Personal Information;</span>
    </p>
    <p class="c2 c10 c8">
      <span class="c3"
        >(b) pemberitahuan tertulis lewat surat elektronik (e-mail) kepada Anda paling lambat 14 (empat belas) hari
        sejak diketahui adanya kegagalan tersebut;</span
      >
    </p>
    <p class="c2 c9">
      <span class="c3"
        >written notification via e-mail to You no later than 14 (fourteen) days after the failure is
        discovered;</span
      >
    </p>
    <p class="c2 c10">
      <span class="c3"
        >(c) menyediakan pihak yang dapat dihubungi (contact person) yang mudah dihubungi oleh Anda terkait
        pengelolaan Informasi Pribadi;</span
      >
    </p>
    <p class="c2 c9">
      <span class="c3"
        >providing a contact person who is easily contacted by You regarding the management of Personal
        Information.</span
      >
    </p>
    <p class="c2 c9 c43"><span class="c3"></span></p>
    <p class="c15 c31"><span class="c20">PASAL 7 &ndash;</span><span class="c14 c12">&nbsp;ARTICLE 7</span></p>
    <p class="c17"><span class="c20">&nbsp;COOKIES &ndash;</span><span class="c14 c12">&nbsp;COOKIES</span></p>
    <p class="c1">
      <span class="c3"
        >7.1 Dengan mengunjungi dan menggunakan Platform, Anda mengetahui bahwa cookies atau teknologi serupa dapat
        terpasang di perangkat Anda. Cookies adalah file yang mencatat informasi seperti jejak pencarian situs dari
        perangkat atau untuk mengumpulkan informasi log internet dan informasi perilaku pengunjung. Saat Anda
        mengunjungi Platform ini lagi, cookies akan memudahkan Kami untuk menyesuaikan konten sesuai dengan kebutuhan
        Anda. Cookies ini tidak melacak informasi Pengguna secara individual, dan semua data cookies Kami telah
        dienkripsi dan tidak dapat dibaca oleh platform lain.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >By visiting and using the Platform, You realize that cookies or similar technologies can be installed on Your
        device. Cookies are files that record information such as site search traces from a device or to collect
        internet log information and visitor behavior information. When You revisit this Platform, cookies will make
        it easier for Us to customize the content to suit Your needs. These cookies do not track individual user
        information, and all of Our cookies data is encrypted and cannot be read by other platforms.</span
      >
    </p>
    <p class="c1">
      <span class="c3">7.2 Kami menggunakan tipe cookies sebagai berikut:</span>
    </p>
    <p class="c6">
      <span class="c25">We use the following types of cookies:</span>
    </p>
    <a id="t.7ee7a419c55262fe33e35989eccc9f8cc37738a9"></a><a id="t.1"></a>
    <table class="c50">
      <tr class="c51">
        <td class="c41" colspan="1" rowspan="1">
          <p class="c8 c49">
            <span class="c27 c44 c20">Kategori dan Keterangan</span>
          </p>
          <p class="c49 c8">
            <span class="c27 c12">Category and Description</span>
          </p>
        </td>
        <td class="c0" colspan="1" rowspan="1">
          <p class="c49 c8">
            <span class="c27 c44 c20">Detil dari Cookies yang Digunakan</span>
          </p>
          <p class="c49 c8">
            <span class="c27 c12">Details of Cookies Used</span>
          </p>
        </td>
      </tr>
      <tr class="c58">
        <td class="c41" colspan="1" rowspan="1">
          <p class="c15 c8">
            <span class="c27 c44 c20">Cookies Yang Wajib Diperlukan</span>
          </p>
          <p class="c15 c8">
            <span class="c12 c27">Strictly Necessary cookies</span>
          </p>
          <p class="c15 c8">
            <span class="c27 c32"
              >Cookie ini sangat penting untuk memungkinkan Anda bergerak di sekitar Platform dan menggunakan
              fitur-fiturnya, seperti mengakses area situs yang aman. Tanpa cookie ini, layanan yang Anda minta tidak
              dapat diberikan.</span
            >
          </p>
          <p class="c15 c8">
            <span class="c21"
              >These cookies are essential in order to enable You to move around the Platform and use its features,
              such as accessing secure areas of the site. Without these cookies, services You have asked for cannot be
              provided.</span
            >
          </p>
        </td>
        <td class="c0" colspan="1" rowspan="1">
          <p class="c2 c10 c8">
            <span class="c27 c32">1. Untuk mengamankan dan melindungi akun Anda dan Platform</span>
          </p>
          <p class="c6">
            <span class="c21">To secure and protect Your user account and the Platform</span>
          </p>
          <p class="c2 c10 c8">
            <span class="c27 c32"
              >2. Untuk memungkinkan Anda untuk melanjutkan atau menyelesaikan permohonan pinjaman atau menggunakan
              layanan lainnya yang Kami sediakan</span
            >
          </p>
          <p class="c6">
            <span class="c21"
              >To enable You to progress or complete a loan application or make use of other online services We
              provide</span
            >
          </p>
          <p class="c15 c8">
            <span class="c27 c32">Cookie ini selalu diaktifkan.</span>
          </p>
          <p class="c15 c8">
            <span class="c21">These cookies are always enabled.</span>
          </p>
        </td>
      </tr>
      <tr class="c46">
        <td class="c41" colspan="1" rowspan="1">
          <p class="c15 c8">
            <span class="c27 c20 c44">Cookies Untuk Kinerja</span>
          </p>
          <p class="c15 c8"><span class="c27 c12">Performance cookies</span></p>
          <p class="c15 c8">
            <span class="c27 c32"
              >Cookie ini mengumpulkan informasi tentang kunjungan Anda dan penggunaan Platform, misalnya halaman mana
              yang paling sering Anda kunjungi, dan jika Anda mendapatkan pesan kesalahan dari halaman web. Cookie ini
              tidak mengumpulkan informasi yang mengidentifikasi pengunjung. Semua informasi yang dikumpulkan cookie
              ini bersifat anonim dan hanya digunakan untuk meningkatkan cara kerja Platform.</span
            >
          </p>
          <p class="c15 c8">
            <span class="c21"
              >These cookies collect information about Your visit and use of the Platform, for instance which pages
              You visit the most often, and if You get error messages from web pages. These cookies don&#39;t collect
              information that identifies a visitor. All information these cookies collect is anonymous and is only
              used to improve how the Platform works.</span
            >
          </p>
        </td>
        <td class="c0" colspan="1" rowspan="1">
          <p class="c2 c10 c8">
            <span class="c27 c32"
              >1. Untuk mengidentifikasi Anda ketika Anda mengunjungi Platform Kami dan untuk membantu Anda menavigasi
              Platform Kami.</span
            >
          </p>
          <p class="c6">
            <span class="c21"
              >To identify You when You visit Our Platform and to help You navigate through Our Platform.</span
            >
          </p>
          <p class="c2 c10 c8">
            <span class="c27 c32">2. Untuk menganalisis penggunaan dan kinerja Platform Kami</span>
          </p>
          <p class="c6">
            <span class="c21">To analyse the use and performance of Our Platform</span>
          </p>
          <p class="c15 c8">
            <span class="c27 c32">Pengaktifan performance tracking cookies adalah pilihan.</span>
          </p>
          <p class="c15 c8">
            <span class="c21">Opt-in for performance tracking cookies.</span>
          </p>
          <p class="c7"><span class="c27 c32">&nbsp;</span></p>
        </td>
      </tr>
      <tr class="c53">
        <td class="c41" colspan="1" rowspan="1">
          <p class="c15 c8">
            <span class="c27 c44 c20">Functionality cookies</span>
          </p>
          <p class="c15 c8">
            <span class="c27 c32"
              >Cookie ini memungkinkan situs mengingat pilihan yang Anda buat (seperti nama pengguna, bahasa, atau
              wilayah tempat Anda berada) dan memberikan fitur pribadi yang lebih disempurnakan.</span
            >
          </p>
          <p class="c15 c8">
            <span class="c27 c32"
              >Cookie ini tidak dapat melacak aktivitas penelusuran Anda di situs web lain. Mereka tidak mengumpulkan
              informasi apa pun tentang Anda yang dapat digunakan untuk beriklan atau mengingat di mana Anda berada di
              Internet di luar situs Kami.</span
            >
          </p>
          <p class="c15 c8">
            <span class="c21"
              >These cookies allow a site to remember choices You make (such as Your user name, language or the region
              You are in) and provide more enhanced, personal features.</span
            >
          </p>
          <p class="c15 c8">
            <span class="c21"
              >These cookies cannot track Your browsing activity on other websites. They don&rsquo;t gather any
              information about You that could be used for advertising or remembering where You&rsquo;ve been on the
              Internet outside Our site.</span
            >
          </p>
        </td>
        <td class="c0" colspan="1" rowspan="1">
          <p class="c2 c10 c8">
            <span class="c27 c32"
              >1. Untuk menyimpan informasi tentang preferensi Anda dan mempersonalisasi Platform untuk Anda.</span
            >
          </p>
          <p class="c6">
            <span class="c21"
              >To store information about Your preferences and to personalise the Platform for You.</span
            >
          </p>
          <p class="c2 c10 c8">
            <span class="c27 c32"
              >2. Untuk membantu menentukan apakah Anda telah logged in sebelumnya ke Platform</span
            >
          </p>
          <p class="c6">
            <span class="c21">To help determine if You are logged into the Platform</span>
          </p>
          <p class="c15 c8">
            <span class="c27 c32">Pengaktifan functionality cookies adalah pilihan.</span>
          </p>
          <p class="c15 c8">
            <span class="c21">Opt-in for functionality cookies</span>
          </p>
          <p class="c7"><span class="c27 c32">&nbsp;</span></p>
        </td>
      </tr>
      <tr class="c52">
        <td class="c41" colspan="1" rowspan="1">
          <p class="c15 c8">
            <span class="c27 c44 c20">Targeting cookies</span>
          </p>
          <p class="c15 c8">
            <span class="c27 c32"
              >Cookie ini digunakan untuk (1) menayangkan iklan yang lebih relevan dengan Anda dan minat Anda; (2)
              membatasi berapa kali Anda melihat iklan; (3) membantu mengukur efektivitas kampanye periklanan; dan (4)
              memahami perilaku masyarakat setelah melihat iklan. Mereka biasanya ditempatkan atas nama jaringan
              periklanan dengan izin operator situs. Mereka ingat bahwa Anda telah mengunjungi sebuah situs dan
              seringkali mereka akan ditautkan ke fungsionalitas situs yang disediakan oleh organisasi lain.</span
            >
          </p>
          <p class="c15 c8">
            <span class="c21"
              >These cookies are used to (1) deliver advertisements more relevant to You and Your interests; (2) limit
              the number of times You see an advertisement; (3) help measure the effectiveness of the advertising
              campaign; and (4) understand people&rsquo;s behaviour after they view an advertisement. They are usually
              placed on behalf of advertising networks with the site operator&rsquo;s permission. They remember that
              You have visited a site and quite often they will be linked to site functionality provided by the other
              organization.</span
            >
          </p>
        </td>
        <td class="c0" colspan="1" rowspan="1">
          <p class="c15 c8">
            <span class="c27 c32">Kami menggunakan cookie ini untuk mendukung iklan online.</span>
          </p>
          <p class="c15 c8">
            <span class="c21">We use these cookies to to support online ads.</span>
          </p>
          <p class="c15 c8">
            <span class="c21">Opt-in for targeting cookies.</span>
          </p>
          <p class="c7"><span class="c27 c32">&nbsp;</span></p>
        </td>
      </tr>
    </table>
    <p class="c7"><span class="c3">&nbsp;</span></p>
    <p class="c1">
      <span class="c3"
        >7.3 Walaupun secara otomatis perangkat komputer Anda akan menerima cookies, Anda dapat menentukan pilihan
        untuk melakukan modifikasi melalui pengaturan situs pencarian Anda yaitu dengan memilih untuk menolak cookies
        dengan menghapus cookies yang terpasang di perangkat Anda setiap saat dengan mengkonfigurasi perangkat lunak
        situs pencarian Anda. Anda mungkin tidak mendapatkan keuntungan dari beberapa Layanan pada Platform jika
        cookies dihapus atau dicegah agar tidak terpasang diperangkat Anda.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >Even though Your computer will automatically accept cookies, You can choose to make modifications through
        Your search site settings by choosing to reject cookies and deleting cookies installed on Your device at any
        time by configuring Your search site software. You may not realize the benefit of some Services on the
        Platform if cookies are deleted or prevented from being installed in Your device.</span
      >
    </p>
    <p class="c7"><span class="c3">&nbsp;</span></p>
    <p class="c15 c31"><span class="c20">PASAL 8 &ndash; </span><span class="c14 c12">ARTICLE 8</span></p>
    <p class="c17">
      <span class="c20">AKSES SOSIAL MEDIA </span><span>&ndash;</span><span class="c25">&nbsp;</span
      ><span class="c14 c12">SOCIAL MEDIA ACCESS</span>
    </p>
    <p class="c1">
      <span class="c3"
        >8.1 Dalam rangka penyediaan Layanan pada Platform, Kami dapat memberikan kepada Anda pilihan untuk menautkan
        dan memberikan Kami akses ke akun lain Anda termasuk namun tidak terbatas pada Twitter, Facebook, Google+
        dan/atau Linkedln, maupun akun Anda pada platform atau aplikasi lainnya. Keputusan untuk menautkan akun-akun
        tersebut di atas dengan profil Anda di situs web Kami sepenuhnya merupakan kebijaksanaan Anda dan Anda tidak
        diwajibkan untuk memberikan akses ke akun lainnya milik Anda.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >In the course of provision of Services on the Platform, We may provide You with the option to link and
        provide Us access to Your other accounts including but not limited to Twitter, Facebook, Google+ and/or
        LinkedIn, or any of Your accounts in other platforms or applications. The decision to link the abovementioned
        accounts with Your profile on Our website is entirely up to Your discretion and You are not required to give
        access to Your other account(s).
      </span>
    </p>
    <p class="c1">
      <span class="c3"
        >8.2 Dalam hal Anda memberikan Kami akses ke data akun lainnya milik Anda, Anda harus memahami bahwa Kami
        hanya menggunakan data tersebut untuk tujuan berikut:</span
      >
    </p>
    <p class="c15 c16 c9">
      <span class="c4"
        >In the event that You give Us access to Your other account(s) data, You must understand that We only use that
        data for the following purposes:</span
      >
    </p>
    <p class="c2 c10"><span class="c3">(a) Verifikasi identitas;</span></p>
    <p class="c2"><span class="c4">Identity verification;</span></p>
    <p class="c2 c10">
      <span class="c3">(b) Mitigasi risiko penipuan identitas;</span>
    </p>
    <p class="c2">
      <span class="c4">Mitigating the risks of identity fraud;</span>
    </p>
    <p class="c2 c10">
      <span class="c3">(c) Statistik analisis/kuantitatif;</span>
    </p>
    <p class="c2">
      <span class="c4">Analytical / quantitative statistics;</span>
    </p>
    <p class="c2 c10">
      <span class="c3"
        >(d) Mematuhi ketentuan, hukum dan peraturan perundang-undangan yang berlaku, atau untuk membantu penegakan
        dan investigasi oleh pihak yang bertanggung jawab;</span
      >
    </p>
    <p class="c2">
      <span class="c4"
        >Comply with any applicable rules, law and regulations, or to assist in law enforcement and investigations by
        authorities.</span
      >
    </p>
    <p class="c2 c10 c36">
      <span class="c3">(e) Memberikan informasi dan menjawab pertanyaan; dan </span>
    </p>
    <p class="c2 c36">
      <span class="c4">Providing information and answering questions; and</span>
    </p>
    <p class="c2 c10">
      <span class="c3">(f) Mencegah penipuan, pencucian uang dan kegiatan kriminal lainnya.</span>
    </p>
    <p class="c2">
      <span class="c4">Preventing fraud, money laundering and other criminal activities.</span>
    </p>
    <p class="c2 c43"><span class="c4"></span></p>
    <p class="c29"><span class="c20">PASAL 9 &ndash; </span><span class="c14 c12">ARTICLE 9</span></p>
    <p class="c17">
      <span class="c20">PERUBAHAN KEBIJAKAN PRIVASI &ndash;</span
      ><span class="c14 c12">&nbsp;CHANGES IN PRIVACY POLICY</span>
    </p>
    <p class="c1">
      <span class="c30">9.1. </span
      ><span class="c3">
        Kebijakan Privasi ini mungkin diubah dan/atau diperbaharui dari waktu ke waktu dengan pemberitahuan terlebih
        dahulu. Kami akan menerbitkan versi terbaru dari Kebijakan Privasi ini di Platform.
      </span>
    </p>
    <p class="c15 c16 c9">
      <span class="c4">
        This Privacy Policy may be changed and/or updated from time to time with prior notice. We will publish the
        latest version of this Privacy Policy on the Platform.
      </span>
    </p>
    <p class="c1">
      <span class="c30">9.2. </span
      ><span class="c3"
        >Anda disarankan untuk membaca secara saksama dan memeriksa Kebijakan Privasi ini dari waktu ke waktu agar
        Anda tetap terinformasikan mengenai perubahan terbaru dalam Kebijakan Privasi ini.</span
      >
    </p>
    <p class="c15 c16 c9">
      <span class="c4"
        >You are advised to carefully read and check this Privacy Policy from time to time so that You remain informed
        about the latest version of this Privacy Policy.</span
      >
    </p>
    <p class="c1">
      <span class="c30">9.3. </span>
      <span class="c3">
        Kami dapat memberitahu Anda tentang perubahan yang dibuat pada Kebijakan Privasi ini melalui surat elektronik
        (e-mail) ke alamat e-mail Anda yang terdaftar, melalui Platform, ataupun metode lainnya yang Kami pandang
        diperlukan.
      </span>
    </p>
    <p class="c15 c16 c9">
      <span class="c4">
        We may notify You of changes made to this Privacy Policy via e-mail to Your registered e-mail address, through
        the Platform, or any other method as we deem necessary.
      </span>
    </p>
    <p class="c1">
      <span class="c30">9.4. </span
      ><span class="c3"
        >Dengan tetap mengakses dan menggunakan Platform dan Layanan, maka Anda menyetujui perubahan-perubahan dalam
        Kebijakan Privasi ini.</span
      >
    </p>
    <p class="c6">
      <span class="c4"
        >By continuing to access and use the Platform and Services, You agree to any changes to this Privacy
        Policy.</span
      >
    </p>
    <p class="c15 c8 c54"><span class="c3">&nbsp;</span></p>
    <p class="c29"><span class="c20">PASAL 10 &ndash;</span><span class="c14 c12">&nbsp;ARTICLE 10</span></p>
    <p class="c17"><span class="c20">LAIN-LAIN &ndash;</span><span class="c14 c12">&nbsp;MISCELLANEOUS</span></p>
    <p class="c15 c9">
      <span class="c3"
        >Kebijakan Privasi ini sesuai dengan peraturan perundang-undangan yang berlaku, termasuk namun tidak terbatas
        pada POJK 10, UU PDP.</span
      >
    </p>
    <p class="c15 c8">
      <span class="c4"
        >This Privacy Policy is in accordance with the prevailing laws and regulations, including but not limited to
        POJK 10, PDP Law.</span
      >
    </p>
    <p class="c8 c11"><span class="c3">&nbsp;</span></p>
    <p class="c29"><span class="c20">PASAL 11 &ndash; </span><span class="c14 c12">ARTICLE 11</span></p>
    <p class="c17"><span class="c20">KONTAK &ndash; </span><span class="c14 c12">CONTACT</span></p>
    <p class="c15 c9">
      <span
        >Apabila ada pertanyaan, komentar dan permintaan mengenai Kebijakan Privasi ini, dapat ditujukan kepada alamat
        email </span
      ><span class="c45">cs@kreditpintar.com</span><span class="c3">.</span>
    </p>
    <p class="c15 c9">
      <span class="c25"
        >If there are any questions, comments and requests regarding this Privacy Policy, please contact </span
      ><span class="c45 c25">cs@kreditpintar.com</span><span class="c4">.</span>
    </p>
    <p class="c15 c9"><span class="c3">&nbsp;</span></p>
    <p class="c15"><span class="c3">&nbsp;</span></p>
    <p class="c15">
      <span class="c42 c24 c22">Diperbaharui terakhir pada Januari 2024.</span>
    </p>
    <p class="c15">
      <span class="c39 c22 c25 c42">Last updated on January 2024.</span>
    </p>
    <p class="c35 c43"><span class="c3"></span></p>
    <p class="c35 c43"><span class="c3"></span></p>
  </div>
</div>`
export const styleContentRaw = `
body {
  background-color: #ffffff;
}

ol {
  margin: 0;
  padding: 0;
}

table td,
table th {
  padding: 0;
}

.privacy-policy {
  width: 100%;
  padding: 5pt 10pt;
  box-sizing: border-box;
}
.title {
  padding-top: 0pt;
  color: rgba(102, 102, 102, 1);
  font-size: 26pt;
  padding-bottom: 3pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.subtitle {
  padding-top: 0pt;
  color: #666666;
  font-size: 15pt;
  padding-bottom: 16pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

li {
  color: rgba(102, 102, 102, 1);
  font-size: 11pt;
  font-family: 'Arial';
}

p {
  margin: 0;
  color: rgba(102, 102, 102, 1);
  font-size: 11pt;
  font-family: 'Arial';
}

h1 {
  padding-top: 20pt;
  color: rgba(102, 102, 102, 1);
  font-size: 20pt;
  padding-bottom: 6pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h2 {
  padding-top: 18pt;
  color: rgba(102, 102, 102, 1);
  font-size: 16pt;
  padding-bottom: 6pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h3 {
  padding-top: 16pt;
  color: #434343;
  font-size: 14pt;
  padding-bottom: 4pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h4 {
  padding-top: 14pt;
  color: #666666;
  font-size: 12pt;
  padding-bottom: 4pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h5 {
  padding-top: 12pt;
  color: #666666;
  font-size: 11pt;
  padding-bottom: 4pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h6 {
  padding-top: 12pt;
  color: #666666;
  font-size: 11pt;
  padding-bottom: 4pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  font-style: italic;
  orphans: 2;
  widows: 2;
  text-align: left;
}

@media only screen and (max-width: 1000px) {
  .privacy-policy .c10 {
    width: calc(100% - 28px);
    padding: 48px 32px 0;
    overflow: hidden;
  }

  .privacy-policy .c10 p,
  .privacy-policy .c10 span {
    font-size: 14px;
    line-height: 20px;
  }
}

@media only screen and (min-width: 1000px) {
  .privacy-policy .c10 {
    width: 75%;
    padding: 20pt 72pt 72pt;
    margin: 80px auto 0;
  }

  .privacy-policy .c10 p,
  .privacy-policy .c10 span {
    font-size: 16px;
    line-height: 24px;
  }
}
.c33 {
  border-right-style: solid;
  padding: 5pt 5pt 5pt 5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 246.8pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c40 {
  border-right-style: solid;
  padding: 0pt 5pt 0pt 5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 216pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c18 {
  border-right-style: solid;
  padding: 0pt 5pt 0pt 5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 246.8pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c41 {
  border-right-style: solid;
  padding: 0pt 5pt 0pt 5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 227.2pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c37 {
  border-right-style: solid;
  padding: 0pt 5pt 0pt 5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 462.8pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c0 {
  border-right-style: solid;
  padding: 0pt 5pt 0pt 5pt;
  border-bottom-color: #000000;
  border-top-width: 1pt;
  border-right-width: 1pt;
  border-left-color: #000000;
  vertical-align: top;
  border-right-color: #000000;
  border-left-width: 1pt;
  border-top-style: solid;
  border-left-style: solid;
  border-bottom-width: 1pt;
  width: 228.8pt;
  border-top-color: #000000;
  border-bottom-style: solid;
}
.c1 {
  margin-left: 18pt;
  padding-top: 0pt;
  text-indent: -18pt;
  padding-bottom: 6pt;
  line-height: 1.0909090909090908;
  orphans: 2;
  widows: 2;
  text-align: left;
  margin-right: 6pt;
}
.c6 {
  margin-left: 18pt;
  padding-top: 0pt;
  padding-bottom: 6pt;
  line-height: 1.0909090909090908;
  orphans: 2;
  widows: 2;
  text-align: left;
  margin-right: 6pt;
}
.c34 {
  margin-left: 36pt;
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.15;
  orphans: 2;
  widows: 2;
  text-align: left;
  height: 11pt;
}
.c17 {
  margin-left: 17pt;
  padding-top: 0pt;
  padding-bottom: 6pt;
  line-height: 1.0909090909090908;
  orphans: 2;
  widows: 2;
  text-align: center;
  margin-right: 17pt;
}
.c7 {
  margin-left: 37pt;
  padding-top: 0pt;
  padding-bottom: 6pt;
  line-height: 1.0909090909090908;
  orphans: 2;
  widows: 2;
  text-align: left;
  margin-right: 6pt;
}
.c29 {
  padding-top: 0pt;
  padding-bottom: 6pt;
  line-height: 1.0909090909090908;
  orphans: 2;
  widows: 2;
  text-align: center;
}
.c4 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: 'Arial';
  font-style: italic;
}
.c3 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: 'Arial';
  font-style: normal;
}
.c19 {
  padding-top: 0pt;
  padding-bottom: 6pt;
  line-height: 1.0909090909090908;
  orphans: 2;
  widows: 2;
  text-align: center;
  margin-right: 17pt;
}
.c2 {
  margin-left: 12pt;
  padding-top: 0pt;
  padding-bottom: 6pt;
  line-height: 1.0909090909090908;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.c21 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10pt;
  font-family: 'Arial';
  font-style: italic;
}
.c11 {
  margin-left: 6pt;
  padding-top: 0pt;
  padding-bottom: 6pt;
  line-height: 1.0909090909090908;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.c13 {
  padding-top: 0pt;
  padding-bottom: 6pt;
  line-height: 1.2;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.c49 {
  padding-top: 0pt;
  padding-bottom: 6pt;
  line-height: 1.0909090909090908;
  orphans: 2;
  widows: 2;
  text-align: center;
}
.c15 {
  padding-top: 0pt;
  padding-bottom: 6pt;
  line-height: 1.0909090909090908;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.c35 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.15;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.c14 {
  color: #000000;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: 'Arial';
}
.c27 {
  color: #000000;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10pt;
  font-family: 'Arial';
}
.c50 {
  border-spacing: 0;
  border-collapse: collapse;
  margin-right: auto;
}
.c23 {
  text-decoration-skip-ink: none;
  -webkit-text-decoration-skip: none;
  color: #1155cc;
  text-decoration: underline;
}
.c45 {
  text-decoration-skip-ink: none;
  -webkit-text-decoration-skip: none;
  color: #0000ff;
  text-decoration: underline;
}
.c5 {
  text-decoration-skip-ink: none;
  -webkit-text-decoration-skip: none;
  font-weight: 700;
  text-decoration: underline;
}
.c42 {
  -webkit-text-decoration-skip: none;
  font-weight: 400;
  text-decoration: underline;
  text-decoration-skip-ink: none;
}
.c24 {
  color: #000000;
  vertical-align: baseline;
  font-family: 'Arial';
  font-style: normal;
}
.c61 {
  background-color: #ffffff;
  font-family: 'Roboto';
  color: #757575;
  font-weight: 400;
}
.c39 {
  color: #000000;
  vertical-align: baseline;
  font-family: 'Arial';
}
.c64 {
  font-weight: 400;
  text-decoration: none;
  font-size: 12pt;
}
.c65 {
  background-color: #ffffff;
  /* max-width: 468pt; */
  /* padding: 72pt 24pt 72pt; */
  padding: 12pt 12pt 0px;
}
.c60 {
  /* margin-left: 144pt;
  margin-right: 152pt; */
}
.c26 {
  margin-left: 27pt;
  text-indent: -9pt;
}
.c12 {
  font-weight: 700;
  font-style: italic;
}
.c32 {
  font-weight: 400;
  font-style: normal;
}
.c31 {
  text-align: center;
  /* margin-left: 152pt;
  margin-right: 152pt; */
}
.c47 {
  color: inherit;
  text-decoration: inherit;
}
.c57 {
  text-indent: -21pt;
}
.c68 {
  height: 72.8pt;
}
.c62 {
  height: 84.8pt;
}
.c63 {
  height: 96.8pt;
}
.c30 {
  font-size: 10pt;
}
.c67 {
  height: 108.8pt;
}
.c56 {
  height: 102.8pt;
}
.c55 {
  background-color: #ffff00;
}
.c22 {
  font-size: 11pt;
}
.c28 {
  margin-left: 57pt;
}
.c16 {
  margin-left: 18pt;
}
.c53 {
  height: 282.8pt;
}
.c25 {
  font-style: italic;
}
.c9 {
  margin-right: 5pt;
}
.c58 {
  height: 192.8pt;
}
.c48 {
  margin-left: 35pt;
}
.c10 {
  text-indent: -18pt;
}
.c66 {
  height: 60.8pt;
}
.c44 {
  font-style: normal;
}
.c52 {
  height: 318.8pt;
}
.c36 {
  /* margin-right: 124pt; */
}
.c8 {
  margin-right: 6pt;
}
.c51 {
  height: 36.8pt;
}
.c20 {
  font-weight: 700;
}
.c43 {
  height: 11pt;
}
.c54 {
  margin-left: 42pt;
}
.c38 {
  margin-left: 27pt;
}
.c46 {
  height: 264.8pt;
}
.c59 {
  margin-left: 36pt;
}
.title {
  padding-top: 0pt;
  color: #000000;
  font-size: 26pt;
  padding-bottom: 3pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.subtitle {
  padding-top: 0pt;
  color: #666666;
  font-size: 15pt;
  padding-bottom: 16pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
li {
  color: #000000;
  font-size: 11pt;
  font-family: 'Arial';
}
p {
  margin: 0;
  color: #000000;
  font-size: 11pt;
  font-family: 'Arial';
}
h1 {
  padding-top: 20pt;
  color: #000000;
  font-size: 20pt;
  padding-bottom: 6pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h2 {
  padding-top: 18pt;
  color: #000000;
  font-size: 16pt;
  padding-bottom: 6pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h3 {
  padding-top: 16pt;
  color: #434343;
  font-size: 14pt;
  padding-bottom: 4pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h4 {
  padding-top: 14pt;
  color: #666666;
  font-size: 12pt;
  padding-bottom: 4pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h5 {
  padding-top: 12pt;
  color: #666666;
  font-size: 11pt;
  padding-bottom: 4pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h6 {
  padding-top: 12pt;
  color: #666666;
  font-size: 11pt;
  padding-bottom: 4pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  font-style: italic;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.c10 {
  padding: 20pt 14px 0px;
}
`

export const BannerBox = styled.div`
  @media only screen and (max-width: 1000px) {
    .doc-content {
      width: 100%;
      padding: 60pt 14px 0;
      overflow: hidden;
      p,
      span {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    .doc-content {
      width: 75%;
      padding: 20pt 72pt 72pt;
      margin: 80px auto 0;
      p,
      span {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
`
